import _slicedToArray from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import axios from 'axios';
import { isArray, isNumber } from 'lodash';
import qs from 'qs';
import { api } from '.';
import { PROVIDER_SOURCE_LIST, QUOTE_PURCHASE_PROBABILITY_MAP, QuoteTagEnum } from '../constants/quote';
import { REQUEST_SUCCESS_CODE } from '../constants/requests';
import { getBusinessInsuranceTypes } from '../localeConstants';
import { OrganizationRoles } from '../shared/generated';
import { filterOutRequestExtraParameters, handleApiRequestSuccessData, handleRequestError } from '../utils/request';
import { convertDayjsTimeToServerStoredTimeData, formatCommonDateAndTimeStr, formatCommonDateStr } from '../utils/time';
import { combineQuoteCoverOptionList, handleCommonInsurerPriceData, handleQuotePriceDateInfo } from './utils/quote';
/**
 * Fetches the remaining quote question set for a given quote ID.
 * @param payload - The payload containing the quote ID.
 * @returns An AsyncResult containing the remaining quote question set, or an error if the request fails.
 */

export var apiGetQuoteQSet = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(quoteId, payload) {
    var res, _err$response, _err$response$data, _err$response$data$de, _err$response$data$de2, message;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return api.post("/quotes/".concat(quoteId, "/qsets/remaining"), payload);

          case 3:
            res = _context.sent;
            return _context.abrupt("return", [res.data]);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            message = (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : (_err$response$data$de = _err$response$data.detail) === null || _err$response$data$de === void 0 ? void 0 : (_err$response$data$de2 = _err$response$data$de[0]) === null || _err$response$data$de2 === void 0 ? void 0 : _err$response$data$de2.msg;
            console.error("Failed to fetch quote qset because: ".concat(message));
            return _context.abrupt("return", [null, _context.t0]);

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function apiGetQuoteQSet(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var apiCreateQuote = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payload) {
    var res, _err$response2, _err$response2$data, _err$response2$data$d, _err$response2$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return api.post("/quotes", payload);

          case 3:
            res = _context2.sent;
            return _context2.abrupt("return", [res.data]);

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            message = (_err$response2 = _context2.t0.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$d = _err$response2$data.detail) === null || _err$response2$data$d === void 0 ? void 0 : (_err$response2$data$d2 = _err$response2$data$d[0]) === null || _err$response2$data$d2 === void 0 ? void 0 : _err$response2$data$d2.msg;
            console.error("Failed to create quote because: ".concat(message));
            return _context2.abrupt("return", [null, _context2.t0]);

          case 12:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));

  return function apiCreateQuote(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * Updates a quote with the given ID using the provided payload.
 * @param id The ID of the quote to update.
 * @param payload The paylo ad containing the updated quote data.
 * @returns An AsyncResult containing either the updated quote data or an error.
 */

export var apiUpdateQuote = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id, payload) {
    var res, _err$response3, _err$response3$data, _err$response3$data$d, _err$response3$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return api.patch("/quotes/".concat(id), payload);

          case 3:
            res = _context3.sent;
            return _context3.abrupt("return", [res.data]);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            message = (_err$response3 = _context3.t0.response) === null || _err$response3 === void 0 ? void 0 : (_err$response3$data = _err$response3.data) === null || _err$response3$data === void 0 ? void 0 : (_err$response3$data$d = _err$response3$data.detail) === null || _err$response3$data$d === void 0 ? void 0 : (_err$response3$data$d2 = _err$response3$data$d[0]) === null || _err$response3$data$d2 === void 0 ? void 0 : _err$response3$data$d2.msg;
            console.error("Failed to update quote because: ".concat(message));
            return _context3.abrupt("return", [null, _context3.t0]);

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 7]]);
  }));

  return function apiUpdateQuote(_x4, _x5) {
    return _ref3.apply(this, arguments);
  };
}();
export function apiUpdatePrice(_x6, _x7) {
  return _apiUpdatePrice.apply(this, arguments);
}
/**
 * Updates a quote as an Admin with the given ID using the provided payload.
 * @param id The ID of the quote to update.
 * @param payload The paylo ad containing the updated quote data.
 * @returns An AsyncResult containing either the updated quote data or an error.
 */

function _apiUpdatePrice() {
  _apiUpdatePrice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee80(id, payload) {
    var res, _err$response27, _err$response27$data, _err$response27$data$, _err$response27$data$2, message;

    return _regeneratorRuntime.wrap(function _callee80$(_context80) {
      while (1) {
        switch (_context80.prev = _context80.next) {
          case 0:
            _context80.prev = 0;
            _context80.next = 3;
            return api.patch("/admin/quotes/".concat(id, "/set-price"), payload);

          case 3:
            res = _context80.sent;
            return _context80.abrupt("return", [res.data]);

          case 7:
            _context80.prev = 7;
            _context80.t0 = _context80["catch"](0);
            message = (_err$response27 = _context80.t0.response) === null || _err$response27 === void 0 ? void 0 : (_err$response27$data = _err$response27.data) === null || _err$response27$data === void 0 ? void 0 : (_err$response27$data$ = _err$response27$data.detail) === null || _err$response27$data$ === void 0 ? void 0 : (_err$response27$data$2 = _err$response27$data$[0]) === null || _err$response27$data$2 === void 0 ? void 0 : _err$response27$data$2.msg;
            console.error("Failed to update quote price because: ".concat(message));
            return _context80.abrupt("return", [null, _context80.t0]);

          case 12:
          case "end":
            return _context80.stop();
        }
      }
    }, _callee80, null, [[0, 7]]);
  }));
  return _apiUpdatePrice.apply(this, arguments);
}

export var apiUpdateAdminQuote = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id, payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return api.patch("/admin/quotes/".concat(id), payload);

          case 3:
            res = _context4.sent;
            return _context4.abrupt("return", [res.data]);

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", handleRequestError(_context4.t0, payload));

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 7]]);
  }));

  return function apiUpdateAdminQuote(_x8, _x9) {
    return _ref4.apply(this, arguments);
  };
}();
/**
 * Sends a quote with the specified ID.
 * @param id - The ID of the quote to send.
 * @returns A promise that resolves to an array containing the sent quote response or an error.
 */

export var apiSendQuote = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id, payload) {
    var res, _err$response4, _err$response7, _err$response7$data, _err$response7$data$d, _err$response7$data$d2, _err$response5, _err$response6, _err$response6$data, message;

    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return api.post("/quotes/".concat(id, "/send"), payload || {});

          case 3:
            res = _context5.sent;
            return _context5.abrupt("return", [res.data]);

          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](0);

            if (!((_context5.t0 === null || _context5.t0 === void 0 ? void 0 : (_err$response4 = _context5.t0.response) === null || _err$response4 === void 0 ? void 0 : _err$response4.status) === 503)) {
              _context5.next = 11;
              break;
            }

            return _context5.abrupt("return", [null, {
              status: _context5.t0 === null || _context5.t0 === void 0 ? void 0 : (_err$response5 = _context5.t0.response) === null || _err$response5 === void 0 ? void 0 : _err$response5.status,
              message: _context5.t0 === null || _context5.t0 === void 0 ? void 0 : (_err$response6 = _context5.t0.response) === null || _err$response6 === void 0 ? void 0 : (_err$response6$data = _err$response6.data) === null || _err$response6$data === void 0 ? void 0 : _err$response6$data.message
            }]);

          case 11:
            message = (_err$response7 = _context5.t0.response) === null || _err$response7 === void 0 ? void 0 : (_err$response7$data = _err$response7.data) === null || _err$response7$data === void 0 ? void 0 : (_err$response7$data$d = _err$response7$data.detail) === null || _err$response7$data$d === void 0 ? void 0 : (_err$response7$data$d2 = _err$response7$data$d[0]) === null || _err$response7$data$d2 === void 0 ? void 0 : _err$response7$data$d2.msg;
            console.error("Failed to send quote because: ".concat(message));
            return _context5.abrupt("return", [null, _context5.t0]);

          case 14:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 7]]);
  }));

  return function apiSendQuote(_x10, _x11) {
    return _ref5.apply(this, arguments);
  };
}();
/**
 * Retrieves the quote documents for a given ID.
 * @param id - The ID of the quote.
 * @returns A promise that resolves to an AsyncResult containing the response data or an error.
 */

export var apiGetQuoteDocuments = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(id, price_id, provider_code) {
    var queryParams, url, res, _err$response$data$de3, _err$response8, _err$response8$data, _err$response8$data$d, _err$response8$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            queryParams = new URLSearchParams();

            if (price_id) {
              queryParams.append('price_id', price_id);
            }

            if (provider_code) {
              queryParams.append('provider_code', provider_code);
            }

            url = "/quotes/".concat(id, "/documents").concat(queryParams.toString() ? '?' + queryParams.toString() : '');
            _context6.next = 7;
            return api.get(url);

          case 7:
            res = _context6.sent;
            return _context6.abrupt("return", [res.data]);

          case 11:
            _context6.prev = 11;
            _context6.t0 = _context6["catch"](0);
            message = (_err$response$data$de3 = (_err$response8 = _context6.t0.response) === null || _err$response8 === void 0 ? void 0 : (_err$response8$data = _err$response8.data) === null || _err$response8$data === void 0 ? void 0 : (_err$response8$data$d = _err$response8$data.detail) === null || _err$response8$data$d === void 0 ? void 0 : (_err$response8$data$d2 = _err$response8$data$d[0]) === null || _err$response8$data$d2 === void 0 ? void 0 : _err$response8$data$d2.msg) !== null && _err$response$data$de3 !== void 0 ? _err$response$data$de3 : 'Unknown error';
            console.error("Failed to retrieve quote documents: ".concat(message));
            return _context6.abrupt("return", [null, _context6.t0]);

          case 16:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 11]]);
  }));

  return function apiGetQuoteDocuments(_x12, _x13, _x14) {
    return _ref6.apply(this, arguments);
  };
}();
export var apiCreatePaymentIntent = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(quoteId) {
    var res, _err$response9, _err$response9$data, _err$response9$data$d, _err$response9$data$d2, message;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return api.post("/quotes/".concat(quoteId, "/create-payment-intent"));

          case 3:
            res = _context7.sent;
            return _context7.abrupt("return", [res.data]);

          case 7:
            _context7.prev = 7;
            _context7.t0 = _context7["catch"](0);
            message = (_err$response9 = _context7.t0.response) === null || _err$response9 === void 0 ? void 0 : (_err$response9$data = _err$response9.data) === null || _err$response9$data === void 0 ? void 0 : (_err$response9$data$d = _err$response9$data.detail) === null || _err$response9$data$d === void 0 ? void 0 : (_err$response9$data$d2 = _err$response9$data$d[0]) === null || _err$response9$data$d2 === void 0 ? void 0 : _err$response9$data$d2.msg;
            console.error("Failed to create payment intent because: ".concat(message));
            return _context7.abrupt("return", [null, _context7.t0]);

          case 12:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 7]]);
  }));

  return function apiCreatePaymentIntent(_x15) {
    return _ref7.apply(this, arguments);
  };
}();
export var apiGetBusinessActivities = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref8) {
    var offset, _ref8$limit, limit, country, quote_id, language, _res$data, res, _err$response10, _err$response10$data, _err$response10$data$, _err$response10$data$2, message;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            offset = _ref8.offset, _ref8$limit = _ref8.limit, limit = _ref8$limit === void 0 ? 1000 : _ref8$limit, country = _ref8.country, quote_id = _ref8.quote_id, language = _ref8.language;
            _context8.prev = 1;
            _context8.next = 4;
            return api.get("/quote_data/business_activities", {
              params: {
                limit: limit,
                offset: offset,
                country: country,
                quote_id: quote_id,
                language: language
              }
            });

          case 4:
            res = _context8.sent;

            if (isArray(res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.data)) {
              res.data.data = res.data.data.map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  label: item.value,
                  value: item.id
                });
              });
            }

            return _context8.abrupt("return", [res.data.data]);

          case 9:
            _context8.prev = 9;
            _context8.t0 = _context8["catch"](1);
            message = (_err$response10 = _context8.t0.response) === null || _err$response10 === void 0 ? void 0 : (_err$response10$data = _err$response10.data) === null || _err$response10$data === void 0 ? void 0 : (_err$response10$data$ = _err$response10$data.detail) === null || _err$response10$data$ === void 0 ? void 0 : (_err$response10$data$2 = _err$response10$data$[0]) === null || _err$response10$data$2 === void 0 ? void 0 : _err$response10$data$2.msg;
            console.error("Failed to fetch business activities because: ".concat(message));
            return _context8.abrupt("return", [null, _context8.t0]);

          case 14:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[1, 9]]);
  }));

  return function apiGetBusinessActivities(_x16) {
    return _ref9.apply(this, arguments);
  };
}();
export var apiGetInsuredBusinessActivities = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref10) {
    var providerCode, offset, _ref10$limit, limit, res, _err$response11, _err$response11$data, _err$response11$data$, _err$response11$data$2, message;

    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            providerCode = _ref10.providerCode, offset = _ref10.offset, _ref10$limit = _ref10.limit, limit = _ref10$limit === void 0 ? 1000 : _ref10$limit;
            _context9.prev = 1;

            if (providerCode) {
              _context9.next = 4;
              break;
            }

            throw Error('Invalid provider code');

          case 4:
            _context9.next = 6;
            return api.get("/insurance_providers/".concat(providerCode, "/activities"), {
              params: {
                limit: limit,
                offset: offset,
                decline: false
              }
            });

          case 6:
            res = _context9.sent;
            return _context9.abrupt("return", [res.data.data]);

          case 10:
            _context9.prev = 10;
            _context9.t0 = _context9["catch"](1);
            message = (_err$response11 = _context9.t0.response) === null || _err$response11 === void 0 ? void 0 : (_err$response11$data = _err$response11.data) === null || _err$response11$data === void 0 ? void 0 : (_err$response11$data$ = _err$response11$data.detail) === null || _err$response11$data$ === void 0 ? void 0 : (_err$response11$data$2 = _err$response11$data$[0]) === null || _err$response11$data$2 === void 0 ? void 0 : _err$response11$data$2.msg;
            console.error("Failed to fetch insured business activities because: ".concat(message));
            return _context9.abrupt("return", [null, _context9.t0]);

          case 15:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[1, 10]]);
  }));

  return function apiGetInsuredBusinessActivities(_x17) {
    return _ref11.apply(this, arguments);
  };
}();
export var apiQueryInsurance = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref12) {
    var country_code, activity_code, res, _err$response12, _err$response12$data, _err$response12$data$, _err$response12$data$2, message;

    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            country_code = _ref12.country_code, activity_code = _ref12.activity_code;
            _context10.prev = 1;
            _context10.next = 4;
            return api.get("/insurance_provider_priority/primary_provider", {
              params: {
                country_code: country_code,
                activity_code: activity_code
              }
            });

          case 4:
            res = _context10.sent;
            return _context10.abrupt("return", [res.data]);

          case 8:
            _context10.prev = 8;
            _context10.t0 = _context10["catch"](1);
            message = (_err$response12 = _context10.t0.response) === null || _err$response12 === void 0 ? void 0 : (_err$response12$data = _err$response12.data) === null || _err$response12$data === void 0 ? void 0 : (_err$response12$data$ = _err$response12$data.detail) === null || _err$response12$data$ === void 0 ? void 0 : (_err$response12$data$2 = _err$response12$data$[0]) === null || _err$response12$data$2 === void 0 ? void 0 : _err$response12$data$2.msg;
            console.error("Failed to query insurance because: ".concat(message));
            return _context10.abrupt("return", [null, _context10.t0]);

          case 13:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[1, 8]]);
  }));

  return function apiQueryInsurance(_x18) {
    return _ref13.apply(this, arguments);
  };
}();
export var hiscoxQuoted = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref14) {
    var quoteId, price, res, _error$response, _error$response$data, _error$response$data$, _error$response$data$2, message;

    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            quoteId = _ref14.quoteId, price = _ref14.price;
            _context11.prev = 1;
            _context11.next = 4;
            return api.post("/quotes/".concat(quoteId, "/quoted"), {
              price: price
            });

          case 4:
            res = _context11.sent;
            return _context11.abrupt("return", res.data);

          case 8:
            _context11.prev = 8;
            _context11.t0 = _context11["catch"](1);
            message = (_error$response = _context11.t0.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : (_error$response$data$ = _error$response$data.detail) === null || _error$response$data$ === void 0 ? void 0 : (_error$response$data$2 = _error$response$data$[0]) === null || _error$response$data$2 === void 0 ? void 0 : _error$response$data$2.msg;
            console.error("Failed to quote Hiscox because: ".concat(message));
            return _context11.abrupt("return", [null, _context11.t0]);

          case 13:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[1, 8]]);
  }));

  return function hiscoxQuoted(_x19) {
    return _ref15.apply(this, arguments);
  };
}();
export var aipGetHiscoxQuoteTurnover = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
    var res, _error$response2, _error$response2$data, _error$response2$data2, _error$response2$data3, message;

    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;
            _context12.next = 3;
            return api.get("/hiscox/turnover");

          case 3:
            res = _context12.sent;
            return _context12.abrupt("return", res.data);

          case 7:
            _context12.prev = 7;
            _context12.t0 = _context12["catch"](0);
            message = (_error$response2 = _context12.t0.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : (_error$response2$data2 = _error$response2$data.detail) === null || _error$response2$data2 === void 0 ? void 0 : (_error$response2$data3 = _error$response2$data2[0]) === null || _error$response2$data3 === void 0 ? void 0 : _error$response2$data3.msg;
            console.error("Failed to get Hiscox quote turnover because: ".concat(message));
            return _context12.abrupt("return", [null, _context12.t0]);

          case 12:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[0, 7]]);
  }));

  return function aipGetHiscoxQuoteTurnover() {
    return _ref16.apply(this, arguments);
  };
}();
export var apiGetAmlinQuoteTurnover = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
    var res, _error$response3, _error$response3$data, _error$response3$data2, _error$response3$data3, message;

    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.prev = 0;
            _context13.next = 3;
            return api.get("/amlin/turnover");

          case 3:
            res = _context13.sent;
            return _context13.abrupt("return", res.data);

          case 7:
            _context13.prev = 7;
            _context13.t0 = _context13["catch"](0);
            message = (_error$response3 = _context13.t0.response) === null || _error$response3 === void 0 ? void 0 : (_error$response3$data = _error$response3.data) === null || _error$response3$data === void 0 ? void 0 : (_error$response3$data2 = _error$response3$data.detail) === null || _error$response3$data2 === void 0 ? void 0 : (_error$response3$data3 = _error$response3$data2[0]) === null || _error$response3$data3 === void 0 ? void 0 : _error$response3$data3.msg;
            console.error("Failed to get Amlin quote turnover because: ".concat(message));
            return _context13.abrupt("return", [null, _context13.t0]);

          case 12:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, null, [[0, 7]]);
  }));

  return function apiGetAmlinQuoteTurnover() {
    return _ref17.apply(this, arguments);
  };
}();
export var apiQueryAmlinQuestions = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(data) {
    var res, _error$response4, _error$response4$data, _error$response4$data2, _error$response4$data3, message;

    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.prev = 0;
            _context14.next = 3;
            return api.post("/amlin/declaration-questions", data);

          case 3:
            res = _context14.sent;
            return _context14.abrupt("return", res.data);

          case 7:
            _context14.prev = 7;
            _context14.t0 = _context14["catch"](0);
            message = (_error$response4 = _context14.t0.response) === null || _error$response4 === void 0 ? void 0 : (_error$response4$data = _error$response4.data) === null || _error$response4$data === void 0 ? void 0 : (_error$response4$data2 = _error$response4$data.detail) === null || _error$response4$data2 === void 0 ? void 0 : (_error$response4$data3 = _error$response4$data2[0]) === null || _error$response4$data3 === void 0 ? void 0 : _error$response4$data3.msg;
            console.error("Failed to query Amlin questions because: ".concat(message));
            return _context14.abrupt("return", [null, _context14.t0]);

          case 12:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, null, [[0, 7]]);
  }));

  return function apiQueryAmlinQuestions(_x20) {
    return _ref18.apply(this, arguments);
  };
}();
export var apiGetDeclarationPage = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(_ref19) {
    var quoteId, res, _err$response13, _err$response13$data, _err$response13$data$, _err$response13$data$2, message;

    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            quoteId = _ref19.quoteId;
            _context15.prev = 1;
            _context15.next = 4;
            return api.get("/hiscox/".concat(quoteId, "/declaration-questions"));

          case 4:
            res = _context15.sent;
            return _context15.abrupt("return", res.data);

          case 8:
            _context15.prev = 8;
            _context15.t0 = _context15["catch"](1);
            message = (_err$response13 = _context15.t0.response) === null || _err$response13 === void 0 ? void 0 : (_err$response13$data = _err$response13.data) === null || _err$response13$data === void 0 ? void 0 : (_err$response13$data$ = _err$response13$data.detail) === null || _err$response13$data$ === void 0 ? void 0 : (_err$response13$data$2 = _err$response13$data$[0]) === null || _err$response13$data$2 === void 0 ? void 0 : _err$response13$data$2.msg;
            console.error("Failed to get declaration page because: ".concat(message));
            return _context15.abrupt("return", [null, _context15.t0]);

          case 13:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15, null, [[1, 8]]);
  }));

  return function apiGetDeclarationPage(_x21) {
    return _ref20.apply(this, arguments);
  };
}();
export var apiGetAmlinPrice = /*#__PURE__*/function () {
  var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(_ref21) {
    var quoteId, pi, pl, res, _error$response5, _error$response5$data, _error$response5$data2, _error$response5$data3, message;

    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            quoteId = _ref21.quoteId, pi = _ref21.pi, pl = _ref21.pl;
            _context16.prev = 1;
            _context16.next = 4;
            return api.get("/amlin/".concat(quoteId, "/price"), {
              params: {
                pi: pi,
                pl: pl
              }
            });

          case 4:
            res = _context16.sent;
            return _context16.abrupt("return", [res.data]);

          case 8:
            _context16.prev = 8;
            _context16.t0 = _context16["catch"](1);
            message = (_error$response5 = _context16.t0.response) === null || _error$response5 === void 0 ? void 0 : (_error$response5$data = _error$response5.data) === null || _error$response5$data === void 0 ? void 0 : (_error$response5$data2 = _error$response5$data.detail) === null || _error$response5$data2 === void 0 ? void 0 : (_error$response5$data3 = _error$response5$data2[0]) === null || _error$response5$data3 === void 0 ? void 0 : _error$response5$data3.msg;
            console.error("Failed to quote Amlin because: ".concat(message));
            return _context16.abrupt("return", [null, _context16.t0]);

          case 13:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, null, [[1, 8]]);
  }));

  return function apiGetAmlinPrice(_x22) {
    return _ref22.apply(this, arguments);
  };
}();
/**
 *  Query the quote by quoteId
 *  @param { string } quoteId - The quoteId
 */

export var apiQueryQuote = /*#__PURE__*/function () {
  var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(quoteId) {
    var res, _err$response14, _err$response14$data, _err$response14$data$, _err$response14$data$2, message;

    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.prev = 0;
            _context17.next = 3;
            return api.get("/quotes/".concat(quoteId));

          case 3:
            res = _context17.sent;
            return _context17.abrupt("return", res.data);

          case 7:
            _context17.prev = 7;
            _context17.t0 = _context17["catch"](0);
            message = (_err$response14 = _context17.t0.response) === null || _err$response14 === void 0 ? void 0 : (_err$response14$data = _err$response14.data) === null || _err$response14$data === void 0 ? void 0 : (_err$response14$data$ = _err$response14$data.detail) === null || _err$response14$data$ === void 0 ? void 0 : (_err$response14$data$2 = _err$response14$data$[0]) === null || _err$response14$data$2 === void 0 ? void 0 : _err$response14$data$2.msg;
            console.error("Failed to query quote because: ".concat(message));
            return _context17.abrupt("return", [null, _context17.t0]);

          case 12:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, null, [[0, 7]]);
  }));

  return function apiQueryQuote(_x23) {
    return _ref23.apply(this, arguments);
  };
}();
/**
 *  Query the business activities options by business country
 *  @param {string} country - The country code
 */

export var apiQueryBusinessActivitiesOption = /*#__PURE__*/function () {
  var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(country, config) {
    var res, _err$response15, _err$response15$data, _err$response15$data$, _err$response15$data$2, message;

    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.prev = 0;
            _context18.next = 3;
            return api.get("/quote_data/business_activities_tips", {
              params: _objectSpread({
                country: country
              }, config)
            });

          case 3:
            res = _context18.sent;

            if (res.data) {
              res.data.data = (res.data.data || []).map(function (item) {
                return _objectSpread(_objectSpread({}, item), {}, {
                  value: item.id,
                  label: item.value
                });
              });
            }

            return _context18.abrupt("return", [res.data]);

          case 8:
            _context18.prev = 8;
            _context18.t0 = _context18["catch"](0);
            message = (_err$response15 = _context18.t0.response) === null || _err$response15 === void 0 ? void 0 : (_err$response15$data = _err$response15.data) === null || _err$response15$data === void 0 ? void 0 : (_err$response15$data$ = _err$response15$data.detail) === null || _err$response15$data$ === void 0 ? void 0 : (_err$response15$data$2 = _err$response15$data$[0]) === null || _err$response15$data$2 === void 0 ? void 0 : _err$response15$data$2.msg;
            console.error("Failed to query business activities because: ".concat(message));
            return _context18.abrupt("return", [null, _context18.t0]);

          case 13:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18, null, [[0, 8]]);
  }));

  return function apiQueryBusinessActivitiesOption(_x24, _x25) {
    return _ref24.apply(this, arguments);
  };
}();
/**
 *  query remaining response data by quoteId and qsetId
 *  @param {Object} data
 *  @param {string} data.quoteId - The quoteId
 *  @param {string} data.qsetId - The qsetId
 */

export var apiQueryRemainingResponse = /*#__PURE__*/function () {
  var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(data) {
    var res, _err$response16, _err$response16$data, _err$response16$data$, _err$response16$data$2, message;

    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _context19.prev = 0;
            _context19.next = 3;
            return api.get("/quotes/".concat(data.quoteId, "/qsets/").concat(data.qsetId));

          case 3:
            res = _context19.sent;
            return _context19.abrupt("return", res.data);

          case 7:
            _context19.prev = 7;
            _context19.t0 = _context19["catch"](0);
            message = (_err$response16 = _context19.t0.response) === null || _err$response16 === void 0 ? void 0 : (_err$response16$data = _err$response16.data) === null || _err$response16$data === void 0 ? void 0 : (_err$response16$data$ = _err$response16$data.detail) === null || _err$response16$data$ === void 0 ? void 0 : (_err$response16$data$2 = _err$response16$data$[0]) === null || _err$response16$data$2 === void 0 ? void 0 : _err$response16$data$2.msg;
            console.error("Failed to query remaining response because: ".concat(message));
            return _context19.abrupt("return", [null, _context19.t0]);

          case 12:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19, null, [[0, 7]]);
  }));

  return function apiQueryRemainingResponse(_x26) {
    return _ref25.apply(this, arguments);
  };
}();
export var apiGetQuotePrices = /*#__PURE__*/function () {
  var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(quoteId) {
    var res, _err$response17, _err$response17$data, _err$response17$data$, _err$response17$data$2, message;

    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            _context20.prev = 0;

            if (quoteId) {
              _context20.next = 3;
              break;
            }

            throw Error('Invalid quote ID');

          case 3:
            _context20.next = 5;
            return api.get("/quotes/".concat(quoteId, "/prices"));

          case 5:
            res = _context20.sent;
            return _context20.abrupt("return", [res.data.data]);

          case 9:
            _context20.prev = 9;
            _context20.t0 = _context20["catch"](0);
            message = (_err$response17 = _context20.t0.response) === null || _err$response17 === void 0 ? void 0 : (_err$response17$data = _err$response17.data) === null || _err$response17$data === void 0 ? void 0 : (_err$response17$data$ = _err$response17$data.detail) === null || _err$response17$data$ === void 0 ? void 0 : (_err$response17$data$2 = _err$response17$data$[0]) === null || _err$response17$data$2 === void 0 ? void 0 : _err$response17$data$2.msg;
            console.error("Failed to fetch quote prices because: ".concat(message));
            return _context20.abrupt("return", [null, _context20.t0]);

          case 14:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20, null, [[0, 9]]);
  }));

  return function apiGetQuotePrices(_x27) {
    return _ref26.apply(this, arguments);
  };
}();
export var apiGetQuoteMessages = /*#__PURE__*/function () {
  var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(quoteId) {
    var _res$data2, res, _err$response18, _err$response18$data, _err$response18$data$, _err$response18$data$2, message;

    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            _context21.prev = 0;

            if (quoteId) {
              _context21.next = 3;
              break;
            }

            throw new Error("Invalid quote id: ".concat(quoteId));

          case 3:
            _context21.next = 5;
            return api.get("/quotes/".concat(quoteId, "/messages"), {
              params: {
                quote_id: quoteId,
                limit: 10000,
                offset: 0
              }
            });

          case 5:
            res = _context21.sent;

            if (isArray(res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.data)) {
              res.data.data = res.data.data.map(function (item) {
                var _item$user, _item$user2, _item$view_by_roles, _item$view_by_roles$f;

                item.updatedAtText = formatCommonDateAndTimeStr(item.updated_at);
                item.userFullName = item.user ? ((_item$user = item.user) === null || _item$user === void 0 ? void 0 : _item$user.first_name) + ' ' + ((_item$user2 = item.user) === null || _item$user2 === void 0 ? void 0 : _item$user2.last_name) : 'Unknown';
                item.isInternalMessage = ((_item$view_by_roles = item.view_by_roles) === null || _item$view_by_roles === void 0 ? void 0 : (_item$view_by_roles$f = _item$view_by_roles.filter(function (role) {
                  return role !== OrganizationRoles.JOVE_ADMIN;
                })) === null || _item$view_by_roles$f === void 0 ? void 0 : _item$view_by_roles$f.length) === 0;
                return item;
              });
            }

            return _context21.abrupt("return", [res.data.data]);

          case 10:
            _context21.prev = 10;
            _context21.t0 = _context21["catch"](0);
            message = (_err$response18 = _context21.t0.response) === null || _err$response18 === void 0 ? void 0 : (_err$response18$data = _err$response18.data) === null || _err$response18$data === void 0 ? void 0 : (_err$response18$data$ = _err$response18$data.detail) === null || _err$response18$data$ === void 0 ? void 0 : (_err$response18$data$2 = _err$response18$data$[0]) === null || _err$response18$data$2 === void 0 ? void 0 : _err$response18$data$2.msg;
            console.error("Failed to fetch quote messages: ".concat(message));
            return _context21.abrupt("return", [null, _context21.t0]);

          case 15:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21, null, [[0, 10]]);
  }));

  return function apiGetQuoteMessages(_x28) {
    return _ref27.apply(this, arguments);
  };
}();
export var apiCreateQuoteMessage = /*#__PURE__*/function () {
  var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(quoteId, payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            _context22.prev = 0;

            if (quoteId) {
              _context22.next = 3;
              break;
            }

            throw new Error("Invalid quote id: ".concat(quoteId));

          case 3:
            _context22.next = 5;
            return api.post("/quotes/".concat(quoteId, "/messages"), payload);

          case 5:
            res = _context22.sent;
            return _context22.abrupt("return", [res.data]);

          case 9:
            _context22.prev = 9;
            _context22.t0 = _context22["catch"](0);
            return _context22.abrupt("return", handleRequestError(_context22.t0));

          case 12:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22, null, [[0, 9]]);
  }));

  return function apiCreateQuoteMessage(_x29, _x30) {
    return _ref28.apply(this, arguments);
  };
}();
export var apiCreateInternalQuoteMessage = /*#__PURE__*/function () {
  var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(quoteId, payload) {
    var res, _err$response19, _err$response19$data, _err$response19$data$, _err$response19$data$2, message;

    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            _context23.prev = 0;

            if (quoteId) {
              _context23.next = 3;
              break;
            }

            throw new Error("Invalid quote id: ".concat(quoteId));

          case 3:
            _context23.next = 5;
            return api.post("/quotes/".concat(quoteId, "/messages/jove-internal"), payload);

          case 5:
            res = _context23.sent;
            return _context23.abrupt("return", [res.data]);

          case 9:
            _context23.prev = 9;
            _context23.t0 = _context23["catch"](0);
            message = (_err$response19 = _context23.t0.response) === null || _err$response19 === void 0 ? void 0 : (_err$response19$data = _err$response19.data) === null || _err$response19$data === void 0 ? void 0 : (_err$response19$data$ = _err$response19$data.detail) === null || _err$response19$data$ === void 0 ? void 0 : (_err$response19$data$2 = _err$response19$data$[0]) === null || _err$response19$data$2 === void 0 ? void 0 : _err$response19$data$2.msg;
            console.error("Failed to create internal quote message: ".concat(message));
            return _context23.abrupt("return", [null, _context23.t0]);

          case 14:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23, null, [[0, 9]]);
  }));

  return function apiCreateInternalQuoteMessage(_x31, _x32) {
    return _ref29.apply(this, arguments);
  };
}();
export var apiUpdateQuoteMessage = /*#__PURE__*/function () {
  var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(messageId, quoteId, payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            _context24.prev = 0;

            if (quoteId) {
              _context24.next = 3;
              break;
            }

            throw new Error("Invalid quote id: ".concat(quoteId));

          case 3:
            if (messageId) {
              _context24.next = 5;
              break;
            }

            throw new Error("Invalid message id: ".concat(messageId));

          case 5:
            _context24.next = 7;
            return api.patch("/quotes/".concat(quoteId, "/messages/").concat(messageId), payload);

          case 7:
            res = _context24.sent;
            return _context24.abrupt("return", [res.data]);

          case 11:
            _context24.prev = 11;
            _context24.t0 = _context24["catch"](0);
            return _context24.abrupt("return", handleRequestError(_context24.t0));

          case 14:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24, null, [[0, 11]]);
  }));

  return function apiUpdateQuoteMessage(_x33, _x34, _x35) {
    return _ref30.apply(this, arguments);
  };
}();
export var apiDeleteQuoteMessage = /*#__PURE__*/function () {
  var _ref31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(messageId, quoteId) {
    var res, _err$response20, _err$response20$data, _err$response20$data$, _err$response20$data$2, message;

    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            _context25.prev = 0;

            if (quoteId) {
              _context25.next = 3;
              break;
            }

            throw new Error("Invalid quote id: ".concat(quoteId));

          case 3:
            if (messageId) {
              _context25.next = 5;
              break;
            }

            throw new Error("Invalid message id: ".concat(messageId));

          case 5:
            _context25.next = 7;
            return api["delete"]("/quotes/".concat(quoteId, "/messages/").concat(messageId));

          case 7:
            res = _context25.sent;
            return _context25.abrupt("return", [res.data || {}]);

          case 11:
            _context25.prev = 11;
            _context25.t0 = _context25["catch"](0);
            message = (_err$response20 = _context25.t0.response) === null || _err$response20 === void 0 ? void 0 : (_err$response20$data = _err$response20.data) === null || _err$response20$data === void 0 ? void 0 : (_err$response20$data$ = _err$response20$data.detail) === null || _err$response20$data$ === void 0 ? void 0 : (_err$response20$data$2 = _err$response20$data$[0]) === null || _err$response20$data$2 === void 0 ? void 0 : _err$response20$data$2.msg;
            console.error("Failed to delete quote message: ".concat(message));
            return _context25.abrupt("return", [null, _context25.t0]);

          case 16:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25, null, [[0, 11]]);
  }));

  return function apiDeleteQuoteMessage(_x36, _x37) {
    return _ref31.apply(this, arguments);
  };
}();
/**
 * Prepares URL search parameters from quote filters
 * @param filters The filter parameters for the quotes
 * @returns URLSearchParams object with all applicable filters
 */

export var prepareQuoteFilterParams = function prepareQuoteFilterParams(_ref32) {
  var _countTags$filter;

  var limit = _ref32.limit,
      offset = _ref32.offset,
      sortOrder = _ref32.sortOrder,
      sortColumn = _ref32.sortColumn,
      search = _ref32.search,
      status = _ref32.status,
      insuranceType = _ref32.insuranceType,
      user_country = _ref32.user_country,
      phone_country = _ref32.phone_country,
      business_country = _ref32.business_country,
      assignee = _ref32.assignee,
      purchaseProbability = _ref32.purchaseProbability,
      createTimeRange = _ref32.createTimeRange,
      tags = _ref32.tags,
      countTags = _ref32.countTags,
      regions = _ref32.regions,
      paymentTimeRange = _ref32.paymentTimeRange,
      purchaseTimeRange = _ref32.purchaseTimeRange,
      minimumPrice = _ref32.minimumPrice,
      maximumPrice = _ref32.maximumPrice,
      renewStatusList = _ref32.renewStatusList,
      utm_source = _ref32.utm_source,
      utm_medium = _ref32.utm_medium,
      utm_campaign = _ref32.utm_campaign,
      organizations = _ref32.organizations,
      insurers = _ref32.insurers,
      partners = _ref32.partners,
      quotingThrough = _ref32.quotingThrough,
      removeDuplicatedList = _ref32.removeDuplicatedList,
      propertyAnalysisNotAvailable = _ref32.propertyAnalysisNotAvailable,
      sanctionCheckReferral = _ref32.sanctionCheckReferral,
      minimumDaysPolicyToExpiry = _ref32.minimumDaysPolicyToExpiry,
      quoteCreationMethodList = _ref32.quoteCreationMethodList,
      paymentStatus = _ref32.paymentStatus,
      referralStatus = _ref32.referralStatus,
      referralTimeRange = _ref32.referralTimeRange,
      referralAssigneeList = _ref32.referralAssigneeList,
      validationStatusList = _ref32.validationStatusList;
  var params = new URLSearchParams();
  params.append('limit', limit.toString());
  params.append('offset', offset.toString());
  params.append('sort_column', sortColumn);
  params.append('sort_order', sortOrder);

  if (search) {
    params.append('search', search);
  }

  status === null || status === void 0 ? void 0 : status.filter(function (i) {
    return i.checked;
  }).forEach(function (i) {
    return params.append('status', i.value);
  });
  assignee === null || assignee === void 0 ? void 0 : assignee.filter(function (i) {
    return i.checked;
  }).forEach(function (i) {
    if (i.value === 'Unassigned') {
      params.append('unassigned', 'true');
    } else {
      params.append('assignee_id', i.value);
    }
  });
  insuranceType === null || insuranceType === void 0 ? void 0 : insuranceType.filter(function (i) {
    return i.checked;
  }).forEach(function (i) {
    return params.append('insurance_type', i.value);
  });
  purchaseProbability === null || purchaseProbability === void 0 ? void 0 : purchaseProbability.filter(function (i) {
    return i.checked;
  }).forEach(function (i) {
    return params.append('purchase_probability', i.value);
  });
  countTags === null || countTags === void 0 ? void 0 : (_countTags$filter = countTags.filter(function (i) {
    return i.checked;
  })) === null || _countTags$filter === void 0 ? void 0 : _countTags$filter.forEach(function (i) {
    return params.append(i.value, i.filterValue);
  });
  regions === null || regions === void 0 ? void 0 : regions.filter(function (i) {
    return i.checked;
  }).forEach(function (i) {
    return params.append('region', i.value);
  });
  insurers === null || insurers === void 0 ? void 0 : insurers.filter(function (i) {
    return i.checked;
  }).forEach(function (i) {
    return params.append('insurer', i.value);
  });

  if (user_country) {
    params.append('customer_country', user_country.code);
  }

  if (phone_country) {
    params.append('phone_country', phone_country.code);
  }

  if (business_country) {
    params.append('business_country', business_country.code);
  } // Create time


  if (isArray(createTimeRange) && createTimeRange[0] && createTimeRange[1]) {
    params.append('created_at_gte', convertDayjsTimeToServerStoredTimeData(createTimeRange[0]));
    params.append('created_at_lt', convertDayjsTimeToServerStoredTimeData(createTimeRange[1].endOf('day')));
  } // Payment time


  if (isArray(paymentTimeRange) && paymentTimeRange[0] && paymentTimeRange[1]) {
    params.append('paid_at_gte', convertDayjsTimeToServerStoredTimeData(paymentTimeRange[0]));
    params.append('paid_at_lt', convertDayjsTimeToServerStoredTimeData(paymentTimeRange[1].endOf('day')));
  } // Purchase time


  if (isArray(purchaseTimeRange) && purchaseTimeRange[0] && purchaseTimeRange[1]) {
    params.append('purchased_at_gte', convertDayjsTimeToServerStoredTimeData(purchaseTimeRange[0]));
    params.append('purchased_at_lt', convertDayjsTimeToServerStoredTimeData(purchaseTimeRange[1].endOf('day')));
  }

  if (isArray(tags)) {
    tags.filter(function (item) {
      return item.checked;
    }).forEach(function (item) {
      if ([QuoteTagEnum().ApiFail.value, QuoteTagEnum().ReachedPayment.value].includes(item.value)) {
        params.append(item.value, '1');
      } else {
        params.append(item.value, 'true');
      }
    });
  } // Price


  if (isNumber(minimumPrice)) {
    params.append('minimum_price', String(minimumPrice));
  }

  if (isNumber(maximumPrice)) {
    params.append('maximum_price', String(maximumPrice));
  }

  if (isNumber(minimumDaysPolicyToExpiry)) {
    params.append('minimum_days_policy_to_expiry', String(minimumDaysPolicyToExpiry));
  }

  if (utm_source) {
    params.append('utm_source', utm_source);
  }

  if (utm_medium) {
    params.append('utm_medium', utm_medium);
  }

  if (utm_campaign) {
    params.append('utm_campaign', utm_campaign);
  } // The source of quote


  quotingThrough === null || quotingThrough === void 0 ? void 0 : quotingThrough.filter(function (i) {
    return i.checked;
  }).forEach(function (i) {
    return params.append('quoting_through', i.value);
  }); // Renew status

  renewStatusList === null || renewStatusList === void 0 ? void 0 : renewStatusList.filter(function (i) {
    return i.checked;
  }).forEach(function (i) {
    return params.append('renew_status', i.value);
  });
  organizations === null || organizations === void 0 ? void 0 : organizations.filter(function (i) {
    return i.checked;
  }).forEach(function (i) {
    return params.append('organization_id', i.value);
  });
  partners === null || partners === void 0 ? void 0 : partners.filter(function (i) {
    return i.checked;
  }).forEach(function (i) {
    return params.append('partner_ids', i.value);
  });
  removeDuplicatedList === null || removeDuplicatedList === void 0 ? void 0 : removeDuplicatedList.filter(function (i) {
    return i.checked;
  }).forEach(function (i) {
    return params.append('remove_duplicated', 'true');
  });
  propertyAnalysisNotAvailable === null || propertyAnalysisNotAvailable === void 0 ? void 0 : propertyAnalysisNotAvailable.filter(function (i) {
    return i.checked;
  }).forEach(function (i) {
    return params.append('property_analysis_not_available', 'true');
  });
  sanctionCheckReferral === null || sanctionCheckReferral === void 0 ? void 0 : sanctionCheckReferral.filter(function (i) {
    return i.checked;
  }).forEach(function (i) {
    return params.append('sanction_check_referral', 'true');
  });
  quoteCreationMethodList === null || quoteCreationMethodList === void 0 ? void 0 : quoteCreationMethodList.filter(function (i) {
    return i.checked;
  }).forEach(function (i) {
    return params.append('quote_creation_methods', i.value);
  });
  paymentStatus === null || paymentStatus === void 0 ? void 0 : paymentStatus.filter(function (i) {
    return i.checked;
  }).forEach(function (i) {
    return params.append('payment_status', i.value);
  });
  referralStatus === null || referralStatus === void 0 ? void 0 : referralStatus.filter(function (i) {
    return i.checked;
  }).forEach(function (i) {
    return params.append('referral_status', i.value);
  }); // Referral time

  if (isArray(referralTimeRange) && referralTimeRange[0] && referralTimeRange[1]) {
    params.append('referral_operated_at_gte', convertDayjsTimeToServerStoredTimeData(referralTimeRange[0]));
    params.append('referral_operated_at_lt', convertDayjsTimeToServerStoredTimeData(referralTimeRange[1].endOf('day')));
  }

  validationStatusList === null || validationStatusList === void 0 ? void 0 : validationStatusList.filter(function (i) {
    return i.checked;
  }).forEach(function (i) {
    return params.append('validation_status', i.value);
  });
  referralAssigneeList === null || referralAssigneeList === void 0 ? void 0 : referralAssigneeList.filter(function (i) {
    return i.checked;
  }).forEach(function (i) {
    if (i.value !== 'Unassigned') {
      params.append('referral_assignee_id', i.value);
    }
  });
  return params;
};
export var apiGetAllQuotes = /*#__PURE__*/function () {
  var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(_ref33, config) {
    var limit, offset, sortOrder, sortColumn, search, status, insuranceType, user_country, phone_country, business_country, assignee, purchaseProbability, createTimeRange, tags, countTags, regions, paymentTimeRange, purchaseTimeRange, minimumPrice, maximumPrice, renewStatusList, utm_source, utm_medium, utm_campaign, organizations, insurers, partners, quotingThrough, removeDuplicatedList, propertyAnalysisNotAvailable, sanctionCheckReferral, minimumDaysPolicyToExpiry, quoteCreationMethodList, paymentStatus, referralStatus, referralTimeRange, referralAssigneeList, validationStatusList, _res$data3, params, res, _err$response21, _err$response21$data, _err$response21$data$, _err$response21$data$2, message;

    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            limit = _ref33.limit, offset = _ref33.offset, sortOrder = _ref33.sortOrder, sortColumn = _ref33.sortColumn, search = _ref33.search, status = _ref33.status, insuranceType = _ref33.insuranceType, user_country = _ref33.user_country, phone_country = _ref33.phone_country, business_country = _ref33.business_country, assignee = _ref33.assignee, purchaseProbability = _ref33.purchaseProbability, createTimeRange = _ref33.createTimeRange, tags = _ref33.tags, countTags = _ref33.countTags, regions = _ref33.regions, paymentTimeRange = _ref33.paymentTimeRange, purchaseTimeRange = _ref33.purchaseTimeRange, minimumPrice = _ref33.minimumPrice, maximumPrice = _ref33.maximumPrice, renewStatusList = _ref33.renewStatusList, utm_source = _ref33.utm_source, utm_medium = _ref33.utm_medium, utm_campaign = _ref33.utm_campaign, organizations = _ref33.organizations, insurers = _ref33.insurers, partners = _ref33.partners, quotingThrough = _ref33.quotingThrough, removeDuplicatedList = _ref33.removeDuplicatedList, propertyAnalysisNotAvailable = _ref33.propertyAnalysisNotAvailable, sanctionCheckReferral = _ref33.sanctionCheckReferral, minimumDaysPolicyToExpiry = _ref33.minimumDaysPolicyToExpiry, quoteCreationMethodList = _ref33.quoteCreationMethodList, paymentStatus = _ref33.paymentStatus, referralStatus = _ref33.referralStatus, referralTimeRange = _ref33.referralTimeRange, referralAssigneeList = _ref33.referralAssigneeList, validationStatusList = _ref33.validationStatusList;
            _context26.prev = 1;
            params = prepareQuoteFilterParams({
              limit: limit,
              offset: offset,
              sortOrder: sortOrder,
              sortColumn: sortColumn,
              search: search,
              status: status,
              insuranceType: insuranceType,
              user_country: user_country,
              phone_country: phone_country,
              business_country: business_country,
              assignee: assignee,
              purchaseProbability: purchaseProbability,
              createTimeRange: createTimeRange,
              tags: tags,
              countTags: countTags,
              regions: regions,
              paymentTimeRange: paymentTimeRange,
              purchaseTimeRange: purchaseTimeRange,
              minimumPrice: minimumPrice,
              maximumPrice: maximumPrice,
              renewStatusList: renewStatusList,
              utm_source: utm_source,
              utm_medium: utm_medium,
              utm_campaign: utm_campaign,
              organizations: organizations,
              insurers: insurers,
              partners: partners,
              quotingThrough: quotingThrough,
              removeDuplicatedList: removeDuplicatedList,
              propertyAnalysisNotAvailable: propertyAnalysisNotAvailable,
              sanctionCheckReferral: sanctionCheckReferral,
              minimumDaysPolicyToExpiry: minimumDaysPolicyToExpiry,
              quoteCreationMethodList: quoteCreationMethodList,
              paymentStatus: paymentStatus,
              referralStatus: referralStatus,
              referralTimeRange: referralTimeRange,
              referralAssigneeList: referralAssigneeList,
              validationStatusList: validationStatusList
            });
            _context26.next = 5;
            return api.get('/quotes', _objectSpread({
              params: params
            }, config));

          case 5:
            res = _context26.sent;

            if (isArray(res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.data)) {
              res.data.data = res.data.data.map(function (item) {
                var _getBusinessInsurance, _PROVIDER_SOURCE_LIST, _QUOTE_PURCHASE_PROBA;

                if (!item.payload) {
                  item.payload = {};
                }

                var _item$payload = item.payload,
                    firstName = _item$payload.firstName,
                    lastName = _item$payload.lastName,
                    insuranceType = _item$payload.insuranceType,
                    providerCode = _item$payload.providerCode,
                    purchaseProbability = _item$payload.purchaseProbability;
                item.createdAtText = formatCommonDateStr(item.createdAt);
                item.updatedAtText = formatCommonDateStr(item.updatedAt);
                item.payload.fullName = "".concat(firstName, " ").concat(lastName);
                item.payload.insuranceTypeText = (_getBusinessInsurance = getBusinessInsuranceTypes().find(function (aItem) {
                  return aItem.value === insuranceType;
                })) === null || _getBusinessInsurance === void 0 ? void 0 : _getBusinessInsurance.label;
                item.payload.insurerText = (_PROVIDER_SOURCE_LIST = PROVIDER_SOURCE_LIST().find(function (aItem) {
                  return aItem.value === providerCode;
                })) === null || _PROVIDER_SOURCE_LIST === void 0 ? void 0 : _PROVIDER_SOURCE_LIST.label;
                item.payload.purchaseProbabilityText = ((_QUOTE_PURCHASE_PROBA = QUOTE_PURCHASE_PROBABILITY_MAP()[purchaseProbability]) === null || _QUOTE_PURCHASE_PROBA === void 0 ? void 0 : _QUOTE_PURCHASE_PROBA.label) || '-';
                item.purchasedAtText = formatCommonDateStr(item.purchasedAt);
                return item;
              });
            }

            return _context26.abrupt("return", [res.data]);

          case 10:
            _context26.prev = 10;
            _context26.t0 = _context26["catch"](1);
            message = (_err$response21 = _context26.t0.response) === null || _err$response21 === void 0 ? void 0 : (_err$response21$data = _err$response21.data) === null || _err$response21$data === void 0 ? void 0 : (_err$response21$data$ = _err$response21$data.detail) === null || _err$response21$data$ === void 0 ? void 0 : (_err$response21$data$2 = _err$response21$data$[0]) === null || _err$response21$data$2 === void 0 ? void 0 : _err$response21$data$2.msg;
            console.error("Failed to fetch quotes because: ".concat(message));
            return _context26.abrupt("return", [null, _context26.t0]);

          case 15:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26, null, [[1, 10]]);
  }));

  return function apiGetAllQuotes(_x38, _x39) {
    return _ref34.apply(this, arguments);
  };
}(); // query quote business works list

export var apiQueryCompanyList = /*#__PURE__*/function () {
  var _ref35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
    var payload,
        data,
        _res$data4,
        _res$data4$results,
        res,
        _args27 = arguments;

    return _regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            payload = _args27.length > 0 && _args27[0] !== undefined ? _args27[0] : {};
            data = _objectSpread({
              offset: 0,
              limit: 5,
              query: ''
            }, payload);
            _context27.prev = 2;
            _context27.next = 5;
            return api.post("/companies_house/search", data);

          case 5:
            res = _context27.sent;

            if (Array.isArray(res === null || res === void 0 ? void 0 : (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : (_res$data4$results = _res$data4.results) === null || _res$data4$results === void 0 ? void 0 : _res$data4$results.items)) {
              res.data.results.items.forEach(function (item) {
                item.value = item.address_snippet;
                item.label = item.name + (payload !== null && payload !== void 0 && payload.hideDisplayMoreAddressLabelInfo ? '' : item.address_snippet);
              });
            }

            return _context27.abrupt("return", [res.data]);

          case 10:
            _context27.prev = 10;
            _context27.t0 = _context27["catch"](2);
            return _context27.abrupt("return", handleRequestError(_context27.t0, data));

          case 13:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee27, null, [[2, 10]]);
  }));

  return function apiQueryCompanyList() {
    return _ref35.apply(this, arguments);
  };
}();
/**
 * query quote business works list
 * @returns
 */

export var apiQueryQuoteBusinessWorksInfo = /*#__PURE__*/function () {
  var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
    var payload,
        res,
        _args28 = arguments;
    return _regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            payload = _args28.length > 0 && _args28[0] !== undefined ? _args28[0] : {
              offset: 1,
              limit: 1000
            };
            _context28.prev = 1;
            _context28.next = 4;
            return api.get("/quote_data/business_works?".concat(qs.stringify(payload)));

          case 4:
            res = _context28.sent;
            return _context28.abrupt("return", [res.data]);

          case 8:
            _context28.prev = 8;
            _context28.t0 = _context28["catch"](1);
            return _context28.abrupt("return", handleRequestError(_context28.t0, payload));

          case 11:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee28, null, [[1, 8]]);
  }));

  return function apiQueryQuoteBusinessWorksInfo() {
    return _ref36.apply(this, arguments);
  };
}();
/**
 * query address by postcode
 * @returns
 */

export var apiQueryAddressByPostcode = /*#__PURE__*/function () {
  var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29() {
    var postcode,
        res,
        _args29 = arguments;
    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            postcode = _args29.length > 0 && _args29[0] !== undefined ? _args29[0] : '';
            res = {};

            try {
              // axios.get(`https://api.getaddress.io/get/${id}?api-key=${process.env['NX_GETADDRESS_API_KEY']}`);
              // The old interface is no longer valid. If this location is used again in the future, please use the new interface.Remove postcode code
              res = {
                data: {
                  suggestions: []
                }
              };
            } catch (_) {}

            return _context29.abrupt("return", [res.data]);

          case 4:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee29);
  }));

  return function apiQueryAddressByPostcode() {
    return _ref37.apply(this, arguments);
  };
}();
/**
 * get address detail info
 * @returns
 */

export var apiGetAddressByDetailInfo = /*#__PURE__*/function () {
  var _ref38 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
    var id,
        res,
        _args30 = arguments;
    return _regeneratorRuntime.wrap(function _callee30$(_context30) {
      while (1) {
        switch (_context30.prev = _context30.next) {
          case 0:
            id = _args30.length > 0 && _args30[0] !== undefined ? _args30[0] : '';
            res = {};

            try {// axios.get(`https://api.getaddress.io/get/${id}?api-key=${process.env['NX_GETADDRESS_API_KEY']}`);
              // The old interface is no longer valid. If this location is used again in the future, please use the new interface.
            } catch (_) {}

            return _context30.abrupt("return", [res.data]);

          case 4:
          case "end":
            return _context30.stop();
        }
      }
    }, _callee30);
  }));

  return function apiGetAddressByDetailInfo() {
    return _ref38.apply(this, arguments);
  };
}();
/**
 * Determining which supplier should be used for the current process
 * @returns
 */

export var apiDetermineQuoteSupplierInfo = /*#__PURE__*/function () {
  var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee31$(_context31) {
      while (1) {
        switch (_context31.prev = _context31.next) {
          case 0:
            _context31.prev = 0;
            _context31.next = 3;
            return api.post("/", payload);

          case 3:
            res = _context31.sent;
            return _context31.abrupt("return", [res.data]);

          case 7:
            _context31.prev = 7;
            _context31.t0 = _context31["catch"](0);
            return _context31.abrupt("return", [null, _context31.t0]);

          case 10:
          case "end":
            return _context31.stop();
        }
      }
    }, _callee31, null, [[0, 7]]);
  }));

  return function apiDetermineQuoteSupplierInfo(_x40) {
    return _ref39.apply(this, arguments);
  };
}();
/* Determine whether the current mailbox is authenticated
 * @returns
 */

export var apiDetermineEmailIsAuthenticated = /*#__PURE__*/function () {
  var _ref40 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee32$(_context32) {
      while (1) {
        switch (_context32.prev = _context32.next) {
          case 0:
            _context32.prev = 0;
            _context32.next = 3;
            return api.get("/users/email_verified?".concat(qs.stringify(payload)));

          case 3:
            res = _context32.sent;
            return _context32.abrupt("return", [res.data]);

          case 7:
            _context32.prev = 7;
            _context32.t0 = _context32["catch"](0);
            return _context32.abrupt("return", handleRequestError(_context32.t0, payload));

          case 10:
          case "end":
            return _context32.stop();
        }
      }
    }, _callee32, null, [[0, 7]]);
  }));

  return function apiDetermineEmailIsAuthenticated(_x41) {
    return _ref40.apply(this, arguments);
  };
}();
/**
 * Query supplier turnover list
 * @returns
 */

export var apiQueryQuoteTurnoverList = /*#__PURE__*/function () {
  var _ref41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee33$(_context33) {
      while (1) {
        switch (_context33.prev = _context33.next) {
          case 0:
            _context33.prev = 0;
            _context33.next = 3;
            return api.get("/quotes/get-turnover?".concat(qs.stringify(payload || {})));

          case 3:
            res = _context33.sent;
            if (!res.data) res.data = [];
            res.data = res.data.map(function (item) {
              return {
                label: item.value,
                value: item.id
              };
            });
            return _context33.abrupt("return", [res.data]);

          case 9:
            _context33.prev = 9;
            _context33.t0 = _context33["catch"](0);
            return _context33.abrupt("return", [null, _context33.t0]);

          case 12:
          case "end":
            return _context33.stop();
        }
      }
    }, _callee33, null, [[0, 9]]);
  }));

  return function apiQueryQuoteTurnoverList(_x42) {
    return _ref41.apply(this, arguments);
  };
}();
/* Send verification email
 * @returns
 */

export var apiSendVerificationEmail = /*#__PURE__*/function () {
  var _ref42 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee34$(_context34) {
      while (1) {
        switch (_context34.prev = _context34.next) {
          case 0:
            _context34.prev = 0;
            _context34.next = 3;
            return api.post("/users/send_verification_email", payload);

          case 3:
            res = _context34.sent;
            return _context34.abrupt("return", [res.data]);

          case 7:
            _context34.prev = 7;
            _context34.t0 = _context34["catch"](0);
            return _context34.abrupt("return", handleRequestError(_context34.t0, payload));

          case 10:
          case "end":
            return _context34.stop();
        }
      }
    }, _callee34, null, [[0, 7]]);
  }));

  return function apiSendVerificationEmail(_x43) {
    return _ref42.apply(this, arguments);
  };
}();
/**
 * Query supplier declarations
 * @returns
 */

export var apiQueryQuoteDeclarations = /*#__PURE__*/function () {
  var _ref43 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee35$(_context35) {
      while (1) {
        switch (_context35.prev = _context35.next) {
          case 0:
            _context35.prev = 0;
            _context35.next = 3;
            return api.get("/quotes/".concat(payload.quoteId, "/declaration-questions"));

          case 3:
            res = _context35.sent;
            return _context35.abrupt("return", [res.data]);

          case 7:
            _context35.prev = 7;
            _context35.t0 = _context35["catch"](0);
            return _context35.abrupt("return", [null, _context35.t0]);

          case 10:
          case "end":
            return _context35.stop();
        }
      }
    }, _callee35, null, [[0, 7]]);
  }));

  return function apiQueryQuoteDeclarations(_x44) {
    return _ref43.apply(this, arguments);
  };
}();
/**
 * Query quote generic documents
 * @returns
 */

export var apiQueryQuoteGenericDocuments = /*#__PURE__*/function () {
  var _ref44 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee36$(_context36) {
      while (1) {
        switch (_context36.prev = _context36.next) {
          case 0:
            _context36.prev = 0;
            _context36.next = 3;
            return api.get("quotes/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId, "/generic_documents?").concat(qs.stringify(payload)));

          case 3:
            res = _context36.sent;

            if (isArray(res.data.data)) {
              res.data.data.forEach(function (item) {
                var _item$revision, _item$document;

                item.title = item === null || item === void 0 ? void 0 : (_item$revision = item.revision) === null || _item$revision === void 0 ? void 0 : _item$revision.filename;

                if (item !== null && item !== void 0 && (_item$document = item.document) !== null && _item$document !== void 0 && _item$document.language) {
                  var _item$document2;

                  item.language = item === null || item === void 0 ? void 0 : (_item$document2 = item.document) === null || _item$document2 === void 0 ? void 0 : _item$document2.language;
                }
              });
            }

            return _context36.abrupt("return", [res.data]);

          case 8:
            _context36.prev = 8;
            _context36.t0 = _context36["catch"](0);
            return _context36.abrupt("return", [null, _context36.t0]);

          case 11:
          case "end":
            return _context36.stop();
        }
      }
    }, _callee36, null, [[0, 8]]);
  }));

  return function apiQueryQuoteGenericDocuments(_x45) {
    return _ref44.apply(this, arguments);
  };
}();
/* get Additional documentation
 * @returns
 */

export var apiGetPaymentSuccessSpecificDocuments = /*#__PURE__*/function () {
  var _ref45 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee37$(_context37) {
      while (1) {
        switch (_context37.prev = _context37.next) {
          case 0:
            _context37.prev = 0;
            _context37.next = 3;
            return api.get("/documents/quote?".concat(qs.stringify({
              quote_id: payload.quote_id
            })));

          case 3:
            res = _context37.sent;
            res.data = (res.data || []).map(function (item) {
              var _item$revision2;

              return _objectSpread(_objectSpread({}, item), {}, {
                filename: item === null || item === void 0 ? void 0 : (_item$revision2 = item.revision) === null || _item$revision2 === void 0 ? void 0 : _item$revision2.filename
              });
            });
            return _context37.abrupt("return", [res.data]);

          case 8:
            _context37.prev = 8;
            _context37.t0 = _context37["catch"](0);
            return _context37.abrupt("return", handleRequestError(_context37.t0, payload));

          case 11:
          case "end":
            return _context37.stop();
        }
      }
    }, _callee37, null, [[0, 8]]);
  }));

  return function apiGetPaymentSuccessSpecificDocuments(_x46) {
    return _ref45.apply(this, arguments);
  };
}();
/**
 * Updates a quote with the given ID using the provided payload. Have toast error info
 * @param id The ID of the quote to update.
 * @param payload The paylo ad containing the updated quote data.
 * @returns An AsyncResult containing either the updated quote data or an error.
 */

export var apiPatchQuote = /*#__PURE__*/function () {
  var _ref46 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(id, payload, config) {
    var res;
    return _regeneratorRuntime.wrap(function _callee38$(_context38) {
      while (1) {
        switch (_context38.prev = _context38.next) {
          case 0:
            _context38.prev = 0;
            _context38.next = 3;
            return api.patch("/quotes_plus/".concat(id), payload, config);

          case 3:
            res = _context38.sent;
            return _context38.abrupt("return", [res.data]);

          case 7:
            _context38.prev = 7;
            _context38.t0 = _context38["catch"](0);
            return _context38.abrupt("return", handleRequestError(_context38.t0, payload));

          case 10:
          case "end":
            return _context38.stop();
        }
      }
    }, _callee38, null, [[0, 7]]);
  }));

  return function apiPatchQuote(_x47, _x48, _x49) {
    return _ref46.apply(this, arguments);
  };
}(); // Query vehicles number

export var apiQueryVehiclesNumberInfo = /*#__PURE__*/function () {
  var _ref47 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee39$(_context39) {
      while (1) {
        switch (_context39.prev = _context39.next) {
          case 0:
            if (payload) {
              payload.hideErrToast = true;
            }

            _context39.prev = 1;
            _context39.next = 4;
            return api.post("/vehicles/search", payload);

          case 4:
            res = _context39.sent;
            return _context39.abrupt("return", [res.data]);

          case 8:
            _context39.prev = 8;
            _context39.t0 = _context39["catch"](1);
            return _context39.abrupt("return", handleRequestError(_context39.t0, payload));

          case 11:
          case "end":
            return _context39.stop();
        }
      }
    }, _callee39, null, [[1, 8]]);
  }));

  return function apiQueryVehiclesNumberInfo(_x50) {
    return _ref47.apply(this, arguments);
  };
}(); // Search company

export var apiSearchCompanyHouse = /*#__PURE__*/function () {
  var _ref48 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee40$(_context40) {
      while (1) {
        switch (_context40.prev = _context40.next) {
          case 0:
            if (!payload.offset) payload.offset = 0;
            if (!payload.offset) payload.limit = 5;
            _context40.prev = 2;
            _context40.next = 5;
            return api.post("/companies_house/search", payload);

          case 5:
            res = _context40.sent;
            return _context40.abrupt("return", [res.data]);

          case 9:
            _context40.prev = 9;
            _context40.t0 = _context40["catch"](2);
            return _context40.abrupt("return", handleRequestError(_context40.t0, payload));

          case 12:
          case "end":
            return _context40.stop();
        }
      }
    }, _callee40, null, [[2, 9]]);
  }));

  return function apiSearchCompanyHouse(_x51) {
    return _ref48.apply(this, arguments);
  };
}(); // Search company key by postcode

export var apiSearchCompanyByPostcode = /*#__PURE__*/function () {
  var _ref49 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee41$(_context41) {
      while (1) {
        switch (_context41.prev = _context41.next) {
          case 0:
            _context41.prev = 0;
            _context41.next = 3;
            return axios.post("https://api.getaddress.io/autocomplete/".concat(payload.query, "?api-key=").concat(process.env['NX_GETADDRESS_API_KEY'], "&expand=true"));

          case 3:
            res = _context41.sent;
            return _context41.abrupt("return", [res === null || res === void 0 ? void 0 : res.data]);

          case 7:
            _context41.prev = 7;
            _context41.t0 = _context41["catch"](0);
            return _context41.abrupt("return", handleRequestError(_context41.t0, payload));

          case 10:
          case "end":
            return _context41.stop();
        }
      }
    }, _callee41, null, [[0, 7]]);
  }));

  return function apiSearchCompanyByPostcode(_x52) {
    return _ref49.apply(this, arguments);
  };
}(); // Search company detail info by address key

export var apiGetCompanyDetailInfoByKey = /*#__PURE__*/function () {
  var _ref50 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee42$(_context42) {
      while (1) {
        switch (_context42.prev = _context42.next) {
          case 0:
            _context42.prev = 0;
            _context42.next = 3;
            return axios.get("https://api.getaddress.io/get/".concat(payload.id, "?api-key=").concat(process.env['NX_GETADDRESS_API_KEY']));

          case 3:
            res = _context42.sent;
            return _context42.abrupt("return", [res === null || res === void 0 ? void 0 : res.data]);

          case 7:
            _context42.prev = 7;
            _context42.t0 = _context42["catch"](0);
            return _context42.abrupt("return", handleRequestError(_context42.t0, payload));

          case 10:
          case "end":
            return _context42.stop();
        }
      }
    }, _callee42, null, [[0, 7]]);
  }));

  return function apiGetCompanyDetailInfoByKey(_x53) {
    return _ref50.apply(this, arguments);
  };
}(); // Get country currency

export var apiQueryCountryCurrency = /*#__PURE__*/function () {
  var _ref51 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee43$(_context43) {
      while (1) {
        switch (_context43.prev = _context43.next) {
          case 0:
            _context43.prev = 0;
            payload.hideErrToast = true;
            _context43.next = 4;
            return api.get("/country/".concat(payload.country));

          case 4:
            res = _context43.sent;
            return _context43.abrupt("return", [res.data]);

          case 8:
            _context43.prev = 8;
            _context43.t0 = _context43["catch"](0);
            return _context43.abrupt("return", handleRequestError(_context43.t0, payload));

          case 11:
          case "end":
            return _context43.stop();
        }
      }
    }, _callee43, null, [[0, 8]]);
  }));

  return function apiQueryCountryCurrency(_x54) {
    return _ref51.apply(this, arguments);
  };
}(); // Quote: confirm purchase

export var apiComfirmQuotePurchase = /*#__PURE__*/function () {
  var _ref52 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee44$(_context44) {
      while (1) {
        switch (_context44.prev = _context44.next) {
          case 0:
            _context44.prev = 0;
            _context44.next = 3;
            return api.post("/quotes/".concat(payload.quoteId, "/confirm"), payload);

          case 3:
            res = _context44.sent;
            return _context44.abrupt("return", [res.data]);

          case 7:
            _context44.prev = 7;
            _context44.t0 = _context44["catch"](0);
            return _context44.abrupt("return", handleRequestError(_context44.t0, payload));

          case 10:
          case "end":
            return _context44.stop();
        }
      }
    }, _callee44, null, [[0, 7]]);
  }));

  return function apiComfirmQuotePurchase(_x55) {
    return _ref52.apply(this, arguments);
  };
}();
export var apiCmsPatchQuote = /*#__PURE__*/function () {
  var _ref53 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(id, payload, config) {
    var res;
    return _regeneratorRuntime.wrap(function _callee45$(_context45) {
      while (1) {
        switch (_context45.prev = _context45.next) {
          case 0:
            _context45.prev = 0;
            _context45.next = 3;
            return api.patch("/admin/quotes_plus/".concat(id), payload, config);

          case 3:
            res = _context45.sent;
            return _context45.abrupt("return", [res.data]);

          case 7:
            _context45.prev = 7;
            _context45.t0 = _context45["catch"](0);
            payload.hideToastStatusCodes = [409];
            return _context45.abrupt("return", handleRequestError(_context45.t0, payload));

          case 11:
          case "end":
            return _context45.stop();
        }
      }
    }, _callee45, null, [[0, 7]]);
  }));

  return function apiCmsPatchQuote(_x56, _x57, _x58) {
    return _ref53.apply(this, arguments);
  };
}();
export var apiQuoteGetQuotePrice = /*#__PURE__*/function () {
  var _ref54 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(payload, config) {
    var _coverOptionsRes, params, res, coverOptionsRes, _res$data5, _res$data6, _coverOptionsRes2;

    return _regeneratorRuntime.wrap(function _callee46$(_context46) {
      while (1) {
        switch (_context46.prev = _context46.next) {
          case 0:
            _context46.prev = 0;
            params = _objectSpread({}, payload);
            delete params.quoteId;
            _context46.next = 5;
            return api.get("/quotes/".concat(payload.quoteId, "/get-price?").concat(qs.stringify(params)));

          case 5:
            res = _context46.sent;
            coverOptionsRes = [];

            if (config !== null && config !== void 0 && config.notRequestCoverOptions) {
              _context46.next = 13;
              break;
            }

            _context46.next = 10;
            return apiGetQuoteCoverOptions(_objectSpread(_objectSpread({}, payload), {}, {
              providerCode: res === null || res === void 0 ? void 0 : (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.provider_code
            }));

          case 10:
            coverOptionsRes = _context46.sent;
            _context46.next = 14;
            break;

          case 13:
            coverOptionsRes = [{
              data: ((_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.covers_options) || {}
            }];

          case 14:
            if ((_coverOptionsRes = coverOptionsRes) !== null && _coverOptionsRes !== void 0 && _coverOptionsRes[0]) {
              combineQuoteCoverOptionList((_coverOptionsRes2 = coverOptionsRes) === null || _coverOptionsRes2 === void 0 ? void 0 : _coverOptionsRes2[0], res.data, {
                useDefault: true
              });
            }

            res.data = handleQuotePriceDateInfo(res.data);
            return _context46.abrupt("return", [res.data]);

          case 19:
            _context46.prev = 19;
            _context46.t0 = _context46["catch"](0);
            return _context46.abrupt("return", handleRequestError(_context46.t0, payload));

          case 22:
          case "end":
            return _context46.stop();
        }
      }
    }, _callee46, null, [[0, 19]]);
  }));

  return function apiQuoteGetQuotePrice(_x59, _x60) {
    return _ref54.apply(this, arguments);
  };
}();
export var apiNewCreateQuote = /*#__PURE__*/function () {
  var _ref55 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee47$(_context47) {
      while (1) {
        switch (_context47.prev = _context47.next) {
          case 0:
            _context47.prev = 0;
            _context47.next = 3;
            return api.post("/quotes_plus", payload);

          case 3:
            res = _context47.sent;
            return _context47.abrupt("return", [res.data]);

          case 7:
            _context47.prev = 7;
            _context47.t0 = _context47["catch"](0);
            return _context47.abrupt("return", handleRequestError(_context47.t0, payload));

          case 10:
          case "end":
            return _context47.stop();
        }
      }
    }, _callee47, null, [[0, 7]]);
  }));

  return function apiNewCreateQuote(_x61) {
    return _ref55.apply(this, arguments);
  };
}();
/**
 * Query quote purchase signature info
 * @returns
 */

export var apiGetQuotePurchaseSignatureInfo = /*#__PURE__*/function () {
  var _ref56 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(payload) {
    var quoteId, res;
    return _regeneratorRuntime.wrap(function _callee48$(_context48) {
      while (1) {
        switch (_context48.prev = _context48.next) {
          case 0:
            quoteId = payload.quote_id;
            delete payload.quote_id;
            _context48.prev = 2;
            _context48.next = 5;
            return api.get("/docusign/".concat(quoteId, "?").concat(qs.stringify(payload)));

          case 5:
            res = _context48.sent;
            return _context48.abrupt("return", [res.data]);

          case 9:
            _context48.prev = 9;
            _context48.t0 = _context48["catch"](2);
            return _context48.abrupt("return", handleRequestError(_context48.t0, payload));

          case 12:
          case "end":
            return _context48.stop();
        }
      }
    }, _callee48, null, [[2, 9]]);
  }));

  return function apiGetQuotePurchaseSignatureInfo(_x62) {
    return _ref56.apply(this, arguments);
  };
}();
/**
 * New quote payment interface
 */

export var apiNewCreatePaymentIntent = /*#__PURE__*/function () {
  var _ref57 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(payload) {
    var queryData, res;
    return _regeneratorRuntime.wrap(function _callee49$(_context49) {
      while (1) {
        switch (_context49.prev = _context49.next) {
          case 0:
            _context49.prev = 0;
            queryData = filterOutRequestExtraParameters(payload);
            delete queryData.quote_id;
            _context49.next = 5;
            return api.post("/quotes/".concat(payload.quote_id, "/create-subscription-schedule?").concat(qs.stringify(queryData)));

          case 5:
            res = _context49.sent;
            return _context49.abrupt("return", [res.data]);

          case 9:
            _context49.prev = 9;
            _context49.t0 = _context49["catch"](0);
            return _context49.abrupt("return", handleRequestError(_context49.t0, payload));

          case 12:
          case "end":
            return _context49.stop();
        }
      }
    }, _callee49, null, [[0, 9]]);
  }));

  return function apiNewCreatePaymentIntent(_x63) {
    return _ref57.apply(this, arguments);
  };
}();
/**
 * Create bank transfer subscription payment intent (currently only used by Great American quotes in the sandbox environment)
 */

export var apiCreateBankTransferSubscription = /*#__PURE__*/function () {
  var _ref58 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(payload) {
    var queryData, res;
    return _regeneratorRuntime.wrap(function _callee50$(_context50) {
      while (1) {
        switch (_context50.prev = _context50.next) {
          case 0:
            _context50.prev = 0;
            queryData = filterOutRequestExtraParameters(payload);
            delete queryData.quote_id;
            _context50.next = 5;
            return api.post("/quotes/".concat(payload.quote_id, "/create-bank-transfer-subscription?").concat(qs.stringify(queryData)));

          case 5:
            res = _context50.sent;
            return _context50.abrupt("return", [res.data]);

          case 9:
            _context50.prev = 9;
            _context50.t0 = _context50["catch"](0);
            return _context50.abrupt("return", handleRequestError(_context50.t0, payload));

          case 12:
          case "end":
            return _context50.stop();
        }
      }
    }, _callee50, null, [[0, 9]]);
  }));

  return function apiCreateBankTransferSubscription(_x64) {
    return _ref58.apply(this, arguments);
  };
}();
/**
 * New quote payment interface
 */

export var apiCreateRetryPaymentIntent = /*#__PURE__*/function () {
  var _ref59 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(payload) {
    var res, _err$response22, _err$response22$data, _err$response22$data$, _err$response22$data$2, message;

    return _regeneratorRuntime.wrap(function _callee51$(_context51) {
      while (1) {
        switch (_context51.prev = _context51.next) {
          case 0:
            _context51.prev = 0;
            _context51.next = 3;
            return api.post("/quotes/".concat(payload.quote_id, "/retry-payment"), payload);

          case 3:
            res = _context51.sent;
            return _context51.abrupt("return", [res.data]);

          case 7:
            _context51.prev = 7;
            _context51.t0 = _context51["catch"](0);
            message = (_err$response22 = _context51.t0.response) === null || _err$response22 === void 0 ? void 0 : (_err$response22$data = _err$response22.data) === null || _err$response22$data === void 0 ? void 0 : (_err$response22$data$ = _err$response22$data.detail) === null || _err$response22$data$ === void 0 ? void 0 : (_err$response22$data$2 = _err$response22$data$[0]) === null || _err$response22$data$2 === void 0 ? void 0 : _err$response22$data$2.msg;
            console.error("Failed to create retry payment intent because: ".concat(message));
            return _context51.abrupt("return", [null, _context51.t0]);

          case 12:
          case "end":
            return _context51.stop();
        }
      }
    }, _callee51, null, [[0, 7]]);
  }));

  return function apiCreateRetryPaymentIntent(_x65) {
    return _ref59.apply(this, arguments);
  };
}();
/**
 * Legacy create quoue
 */

export var apiCreateLegacyQuote = /*#__PURE__*/function () {
  var _ref60 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52(payload) {
    var res, _err$response23, _err$response23$data, _err$response23$data$, _err$response23$data$2, message;

    return _regeneratorRuntime.wrap(function _callee52$(_context52) {
      while (1) {
        switch (_context52.prev = _context52.next) {
          case 0:
            _context52.prev = 0;
            _context52.next = 3;
            return api.post("/legacy/quotes", payload);

          case 3:
            res = _context52.sent;
            return _context52.abrupt("return", [res.data]);

          case 7:
            _context52.prev = 7;
            _context52.t0 = _context52["catch"](0);
            message = (_err$response23 = _context52.t0.response) === null || _err$response23 === void 0 ? void 0 : (_err$response23$data = _err$response23.data) === null || _err$response23$data === void 0 ? void 0 : (_err$response23$data$ = _err$response23$data.detail) === null || _err$response23$data$ === void 0 ? void 0 : (_err$response23$data$2 = _err$response23$data$[0]) === null || _err$response23$data$2 === void 0 ? void 0 : _err$response23$data$2.msg;
            console.error("Failed to create quote because: ".concat(message));
            return _context52.abrupt("return", [null, _context52.t0]);

          case 12:
          case "end":
            return _context52.stop();
        }
      }
    }, _callee52, null, [[0, 7]]);
  }));

  return function apiCreateLegacyQuote(_x66) {
    return _ref60.apply(this, arguments);
  };
}();
/**
 * Pre-load the quote signed document
 */

export var apiPreLoadSignedDocument = /*#__PURE__*/function () {
  var _ref61 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(payload) {
    var parmas;
    return _regeneratorRuntime.wrap(function _callee53$(_context53) {
      while (1) {
        switch (_context53.prev = _context53.next) {
          case 0:
            _context53.prev = 0;
            parmas = _objectSpread({}, payload);
            delete parmas.quoteId; // No need to await

            api.post("/great_american/".concat(payload.quoteId, "/generate-docusign?").concat(qs.stringify(parmas)), payload);
            return _context53.abrupt("return", [{}]);

          case 7:
            _context53.prev = 7;
            _context53.t0 = _context53["catch"](0);
            return _context53.abrupt("return", [null, _context53.t0]);

          case 10:
          case "end":
            return _context53.stop();
        }
      }
    }, _callee53, null, [[0, 7]]);
  }));

  return function apiPreLoadSignedDocument(_x67) {
    return _ref61.apply(this, arguments);
  };
}();
/**
 * Resend quote email documents
 */

export var apiResendQuoteEmailDocuments = /*#__PURE__*/function () {
  var _ref62 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee54$(_context54) {
      while (1) {
        switch (_context54.prev = _context54.next) {
          case 0:
            _context54.prev = 0;
            _context54.next = 3;
            return api.post("/policies/admin/".concat(payload.quoteId, "/send-docs-email"), payload);

          case 3:
            res = _context54.sent;
            return _context54.abrupt("return", [res.data]);

          case 7:
            _context54.prev = 7;
            _context54.t0 = _context54["catch"](0);
            return _context54.abrupt("return", handleRequestError(_context54.t0, payload));

          case 10:
          case "end":
            return _context54.stop();
        }
      }
    }, _callee54, null, [[0, 7]]);
  }));

  return function apiResendQuoteEmailDocuments(_x68) {
    return _ref62.apply(this, arguments);
  };
}();
/**
 * Cancel quote payment
 */

export var apiCancelQuotePayment = /*#__PURE__*/function () {
  var _ref63 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee55$(_context55) {
      while (1) {
        switch (_context55.prev = _context55.next) {
          case 0:
            _context55.prev = 0;
            _context55.next = 3;
            return api.post("/quotes/".concat(payload.quoteId, "/cancel-subscription"), payload);

          case 3:
            res = _context55.sent;
            return _context55.abrupt("return", [res.data]);

          case 7:
            _context55.prev = 7;
            _context55.t0 = _context55["catch"](0);
            return _context55.abrupt("return", handleRequestError(_context55.t0, payload));

          case 10:
          case "end":
            return _context55.stop();
        }
      }
    }, _callee55, null, [[0, 7]]);
  }));

  return function apiCancelQuotePayment(_x69) {
    return _ref63.apply(this, arguments);
  };
}(); // Query the quote signature document list

export var apiGetQuoteSignatureDocumentList = /*#__PURE__*/function () {
  var _ref64 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee56$(_context56) {
      while (1) {
        switch (_context56.prev = _context56.next) {
          case 0:
            _context56.prev = 0;
            res = void 0;

            if (!((payload === null || payload === void 0 ? void 0 : payload.source_type) === 'cms')) {
              _context56.next = 8;
              break;
            }

            _context56.next = 5;
            return api.get("/admin/quote_documents?".concat(qs.stringify(payload)));

          case 5:
            res = _context56.sent;
            _context56.next = 11;
            break;

          case 8:
            _context56.next = 10;
            return api.get("/quote_documents?".concat(qs.stringify(payload)));

          case 10:
            res = _context56.sent;

          case 11:
            if (res.data) {
              res.data.data = (res.data.data || []).map(function (item) {
                var _item$quote_document;

                return _objectSpread(_objectSpread(_objectSpread({}, item.quote_document), {}, {
                  title: item === null || item === void 0 ? void 0 : (_item$quote_document = item.quote_document) === null || _item$quote_document === void 0 ? void 0 : _item$quote_document.name
                }, item), {}, {
                  canDownload: true
                });
              });
            }

            return _context56.abrupt("return", [res.data]);

          case 15:
            _context56.prev = 15;
            _context56.t0 = _context56["catch"](0);
            return _context56.abrupt("return", handleRequestError(_context56.t0, payload));

          case 18:
          case "end":
            return _context56.stop();
        }
      }
    }, _callee56, null, [[0, 15]]);
  }));

  return function apiGetQuoteSignatureDocumentList(_x70) {
    return _ref64.apply(this, arguments);
  };
}();
export var apiGetQuoteCoverOptions = /*#__PURE__*/function () {
  var _ref65 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee57$(_context57) {
      while (1) {
        switch (_context57.prev = _context57.next) {
          case 0:
            if (payload) {
              payload.hideErrToast = true;
            }

            _context57.prev = 1;
            _context57.next = 4;
            return api.get("/quotes/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId, "/get-covers-options"));

          case 4:
            res = _context57.sent;
            return _context57.abrupt("return", [res.data]);

          case 8:
            _context57.prev = 8;
            _context57.t0 = _context57["catch"](1);
            return _context57.abrupt("return", handleRequestError(_context57.t0, payload));

          case 11:
          case "end":
            return _context57.stop();
        }
      }
    }, _callee57, null, [[1, 8]]);
  }));

  return function apiGetQuoteCoverOptions(_x71) {
    return _ref65.apply(this, arguments);
  };
}();
export var apiQuoteGetAdminQuotePrice = /*#__PURE__*/function () {
  var _ref66 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58(payload, config) {
    var _coverOptionsRes3, params, res, coverOptionsRes, _res$data7, _res$data8, _coverOptionsRes4, _handleCommonInsurerP, _handleCommonInsurerP2, cover1, cover2;

    return _regeneratorRuntime.wrap(function _callee58$(_context58) {
      while (1) {
        switch (_context58.prev = _context58.next) {
          case 0:
            _context58.prev = 0;
            params = _objectSpread({}, payload);
            delete params.quoteId;
            _context58.next = 5;
            return api.get("/admin/quotes/".concat(payload.quoteId, "/get-price?").concat(qs.stringify(params)), config);

          case 5:
            res = _context58.sent;
            coverOptionsRes = [];

            if (config !== null && config !== void 0 && config.notRequestCoverOptions) {
              _context58.next = 13;
              break;
            }

            _context58.next = 10;
            return apiGetQuoteCoverOptions(_objectSpread(_objectSpread({}, payload), {}, {
              providerCode: res === null || res === void 0 ? void 0 : (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : _res$data7.provider_code
            }));

          case 10:
            coverOptionsRes = _context58.sent;
            _context58.next = 14;
            break;

          case 13:
            coverOptionsRes = [{
              data: ((_res$data8 = res.data) === null || _res$data8 === void 0 ? void 0 : _res$data8.covers_options) || {}
            }];

          case 14:
            if ((_coverOptionsRes3 = coverOptionsRes) !== null && _coverOptionsRes3 !== void 0 && _coverOptionsRes3[0]) {
              combineQuoteCoverOptionList((_coverOptionsRes4 = coverOptionsRes) === null || _coverOptionsRes4 === void 0 ? void 0 : _coverOptionsRes4[0], res.data, {
                useDefault: true
              });
            }

            _handleCommonInsurerP = handleCommonInsurerPriceData(res.data, {}), _handleCommonInsurerP2 = _slicedToArray(_handleCommonInsurerP, 2), cover1 = _handleCommonInsurerP2[0], cover2 = _handleCommonInsurerP2[1];
            res.data = {
              priceDetailInfo: handleQuotePriceDateInfo(res.data),
              coverOptions: _objectSpread(_objectSpread({}, cover1), cover2)
            };
            return _context58.abrupt("return", [res.data]);

          case 20:
            _context58.prev = 20;
            _context58.t0 = _context58["catch"](0);
            return _context58.abrupt("return", handleRequestError(_context58.t0, payload));

          case 23:
          case "end":
            return _context58.stop();
        }
      }
    }, _callee58, null, [[0, 20]]);
  }));

  return function apiQuoteGetAdminQuotePrice(_x72, _x73) {
    return _ref66.apply(this, arguments);
  };
}();
export var apiSetQuoteNotInterested = /*#__PURE__*/function () {
  var _ref67 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee59$(_context59) {
      while (1) {
        switch (_context59.prev = _context59.next) {
          case 0:
            _context59.prev = 0;
            _context59.next = 3;
            return api.patch("/admin/quotes/".concat(payload.quoteId, "/not-interested"));

          case 3:
            res = _context59.sent;
            return _context59.abrupt("return", [res.data]);

          case 7:
            _context59.prev = 7;
            _context59.t0 = _context59["catch"](0);
            return _context59.abrupt("return", handleRequestError(_context59.t0, payload));

          case 10:
          case "end":
            return _context59.stop();
        }
      }
    }, _callee59, null, [[0, 7]]);
  }));

  return function apiSetQuoteNotInterested(_x74) {
    return _ref67.apply(this, arguments);
  };
}();
export var apiSetQuoteAsProspect = /*#__PURE__*/function () {
  var _ref68 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee60$(_context60) {
      while (1) {
        switch (_context60.prev = _context60.next) {
          case 0:
            _context60.prev = 0;
            _context60.next = 3;
            return api.patch("/admin/quotes/".concat(payload.quoteId, "/prospect"), payload);

          case 3:
            res = _context60.sent;
            return _context60.abrupt("return", [res.data]);

          case 7:
            _context60.prev = 7;
            _context60.t0 = _context60["catch"](0);
            return _context60.abrupt("return", handleRequestError(_context60.t0, payload));

          case 10:
          case "end":
            return _context60.stop();
        }
      }
    }, _callee60, null, [[0, 7]]);
  }));

  return function apiSetQuoteAsProspect(_x75) {
    return _ref68.apply(this, arguments);
  };
}();
export var apiResendDocusign = /*#__PURE__*/function () {
  var _ref69 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee61$(_context61) {
      while (1) {
        switch (_context61.prev = _context61.next) {
          case 0:
            _context61.prev = 0;
            _context61.next = 3;
            return api.patch("/docusign/".concat(payload.quoteId, "/resend"));

          case 3:
            res = _context61.sent;
            return _context61.abrupt("return", [res.data]);

          case 7:
            _context61.prev = 7;
            _context61.t0 = _context61["catch"](0);
            return _context61.abrupt("return", handleRequestError(_context61.t0, payload));

          case 10:
          case "end":
            return _context61.stop();
        }
      }
    }, _callee61, null, [[0, 7]]);
  }));

  return function apiResendDocusign(_x76) {
    return _ref69.apply(this, arguments);
  };
}();
export var apiDirectlyReplaceProvider = /*#__PURE__*/function () {
  var _ref70 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee62$(_context62) {
      while (1) {
        switch (_context62.prev = _context62.next) {
          case 0:
            _context62.prev = 0;
            _context62.next = 3;
            return api.patch("/quotes/".concat(payload.quoteId, "/change_provider"), payload);

          case 3:
            res = _context62.sent;
            return _context62.abrupt("return", [res.data]);

          case 7:
            _context62.prev = 7;
            _context62.t0 = _context62["catch"](0);
            return _context62.abrupt("return", handleRequestError(_context62.t0, payload));

          case 10:
          case "end":
            return _context62.stop();
        }
      }
    }, _callee62, null, [[0, 7]]);
  }));

  return function apiDirectlyReplaceProvider(_x77) {
    return _ref70.apply(this, arguments);
  };
}();
/**
 * Generate a file report for quotes
 * @param payload - Configuration object for the report generation
 * @param payload.entity_name - The entity type to generate the report for (e.g., 'quote')
 * @param payload.format_type - The format of the report (e.g., 'csv')
 * @param payload.filter_settings - Object containing the filters to apply
 * @returns AsyncResult with the report generation response
 */

export var apiGenerateFileReport = /*#__PURE__*/function () {
  var _ref71 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63(payload) {
    var res, _err$response24, _err$response24$data, _err$response24$data$, _err$response24$data$2, message;

    return _regeneratorRuntime.wrap(function _callee63$(_context63) {
      while (1) {
        switch (_context63.prev = _context63.next) {
          case 0:
            _context63.prev = 0;
            _context63.next = 3;
            return api.post('/file_reports', payload);

          case 3:
            res = _context63.sent;
            return _context63.abrupt("return", [res.data]);

          case 7:
            _context63.prev = 7;
            _context63.t0 = _context63["catch"](0);
            message = (_err$response24 = _context63.t0.response) === null || _err$response24 === void 0 ? void 0 : (_err$response24$data = _err$response24.data) === null || _err$response24$data === void 0 ? void 0 : (_err$response24$data$ = _err$response24$data.detail) === null || _err$response24$data$ === void 0 ? void 0 : (_err$response24$data$2 = _err$response24$data$[0]) === null || _err$response24$data$2 === void 0 ? void 0 : _err$response24$data$2.msg;
            console.error("Failed to generate file report because: ".concat(message));
            return _context63.abrupt("return", [null, _context63.t0]);

          case 12:
          case "end":
            return _context63.stop();
        }
      }
    }, _callee63, null, [[0, 7]]);
  }));

  return function apiGenerateFileReport(_x78) {
    return _ref71.apply(this, arguments);
  };
}();
/**
 * Get the status and information about a file report
 * @param reportId - The ID of the report to check
 * @returns AsyncResult with the report status and download URL if available
 */

export var apiGetFileReport = /*#__PURE__*/function () {
  var _ref72 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64(reportId) {
    var res, _err$response25, _err$response25$data, _err$response25$data$, _err$response25$data$2, message;

    return _regeneratorRuntime.wrap(function _callee64$(_context64) {
      while (1) {
        switch (_context64.prev = _context64.next) {
          case 0:
            _context64.prev = 0;
            _context64.next = 3;
            return api.get("/file_reports/".concat(reportId));

          case 3:
            res = _context64.sent;
            return _context64.abrupt("return", [res.data]);

          case 7:
            _context64.prev = 7;
            _context64.t0 = _context64["catch"](0);
            message = (_err$response25 = _context64.t0.response) === null || _err$response25 === void 0 ? void 0 : (_err$response25$data = _err$response25.data) === null || _err$response25$data === void 0 ? void 0 : (_err$response25$data$ = _err$response25$data.detail) === null || _err$response25$data$ === void 0 ? void 0 : (_err$response25$data$2 = _err$response25$data$[0]) === null || _err$response25$data$2 === void 0 ? void 0 : _err$response25$data$2.msg;
            console.error("Failed to get file report status because: ".concat(message));
            return _context64.abrupt("return", [null, _context64.t0]);

          case 12:
          case "end":
            return _context64.stop();
        }
      }
    }, _callee64, null, [[0, 7]]);
  }));

  return function apiGetFileReport(_x79) {
    return _ref72.apply(this, arguments);
  };
}();
/**
 * Download a file report directly using streaming response from the API
 * @param reportId - The ID of the report to download
 * @returns Promise that resolves to a Blob of the file content
 */

export var apiDownloadFileReport = /*#__PURE__*/function () {
  var _ref73 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65(reportId) {
    var response, _err$response26, _err$response26$data, _err$response26$data$, _err$response26$data$2, message;

    return _regeneratorRuntime.wrap(function _callee65$(_context65) {
      while (1) {
        switch (_context65.prev = _context65.next) {
          case 0:
            _context65.prev = 0;
            _context65.next = 3;
            return api.get("/file_reports/".concat(reportId, "/download"), {
              responseType: 'blob'
            });

          case 3:
            response = _context65.sent;
            return _context65.abrupt("return", new Blob([response.data], {
              type: response.headers['content-type']
            }));

          case 7:
            _context65.prev = 7;
            _context65.t0 = _context65["catch"](0);
            message = (_err$response26 = _context65.t0.response) === null || _err$response26 === void 0 ? void 0 : (_err$response26$data = _err$response26.data) === null || _err$response26$data === void 0 ? void 0 : (_err$response26$data$ = _err$response26$data.detail) === null || _err$response26$data$ === void 0 ? void 0 : (_err$response26$data$2 = _err$response26$data$[0]) === null || _err$response26$data$2 === void 0 ? void 0 : _err$response26$data$2.msg;
            console.error("Failed to download file report because: ".concat(message));
            throw _context65.t0;

          case 12:
          case "end":
            return _context65.stop();
        }
      }
    }, _callee65, null, [[0, 7]]);
  }));

  return function apiDownloadFileReport(_x80) {
    return _ref73.apply(this, arguments);
  };
}(); // Repair quote data

export var apiRepairQuoteDataForquote = /*#__PURE__*/function () {
  var _ref74 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee66(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee66$(_context66) {
      while (1) {
        switch (_context66.prev = _context66.next) {
          case 0:
            _context66.prev = 0;
            _context66.next = 3;
            return api.patch("/quotes_plus/revise-quote-after-purchase/".concat(payload.quote_id), payload);

          case 3:
            res = _context66.sent;
            return _context66.abrupt("return", [res.data]);

          case 7:
            _context66.prev = 7;
            _context66.t0 = _context66["catch"](0);
            return _context66.abrupt("return", handleRequestError(_context66.t0, payload));

          case 10:
          case "end":
            return _context66.stop();
        }
      }
    }, _callee66, null, [[0, 7]]);
  }));

  return function apiRepairQuoteDataForquote(_x81) {
    return _ref74.apply(this, arguments);
  };
}();
export var apiGetQuoteBasicConfigurationInfo = /*#__PURE__*/function () {
  var _ref75 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee67(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee67$(_context67) {
      while (1) {
        switch (_context67.prev = _context67.next) {
          case 0:
            _context67.prev = 0;
            _context67.next = 3;
            return api.get("/quotes/options/".concat(payload === null || payload === void 0 ? void 0 : payload.providerCode));

          case 3:
            res = _context67.sent;
            handleApiRequestSuccessData(res);
            return _context67.abrupt("return", [res.data]);

          case 8:
            _context67.prev = 8;
            _context67.t0 = _context67["catch"](0);
            return _context67.abrupt("return", handleRequestError(_context67.t0, payload));

          case 11:
          case "end":
            return _context67.stop();
        }
      }
    }, _callee67, null, [[0, 8]]);
  }));

  return function apiGetQuoteBasicConfigurationInfo(_x82) {
    return _ref75.apply(this, arguments);
  };
}();
export var apiCreatePaymentSetupIntent = /*#__PURE__*/function () {
  var _ref76 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee68(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee68$(_context68) {
      while (1) {
        switch (_context68.prev = _context68.next) {
          case 0:
            _context68.prev = 0;
            _context68.next = 3;
            return api.post("/quotes/".concat(payload.quote_id, "/create_setup_intent"), payload);

          case 3:
            res = _context68.sent;
            handleApiRequestSuccessData(res);
            return _context68.abrupt("return", [res.data]);

          case 8:
            _context68.prev = 8;
            _context68.t0 = _context68["catch"](0);
            return _context68.abrupt("return", handleRequestError(_context68.t0, payload));

          case 11:
          case "end":
            return _context68.stop();
        }
      }
    }, _callee68, null, [[0, 8]]);
  }));

  return function apiCreatePaymentSetupIntent(_x83) {
    return _ref76.apply(this, arguments);
  };
}();
export var apiQueryQuoteMissingInformations = /*#__PURE__*/function () {
  var _ref77 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee69(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee69$(_context69) {
      while (1) {
        switch (_context69.prev = _context69.next) {
          case 0:
            _context69.prev = 0;
            _context69.next = 3;
            return api.get("/general/document_download_url/48f577b7-c411-46b0-ad62-77eb1c589f10");

          case 3:
            res = _context69.sent;
            handleApiRequestSuccessData(res);
            return _context69.abrupt("return", [res.data]);

          case 8:
            _context69.prev = 8;
            _context69.t0 = _context69["catch"](0);
            return _context69.abrupt("return", handleRequestError(_context69.t0, payload));

          case 11:
          case "end":
            return _context69.stop();
        }
      }
    }, _callee69, null, [[0, 8]]);
  }));

  return function apiQueryQuoteMissingInformations(_x84) {
    return _ref77.apply(this, arguments);
  };
}();
export var apiGetQuoteValidationInfoAfterPurchase = /*#__PURE__*/function () {
  var _ref78 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee70(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee70$(_context70) {
      while (1) {
        switch (_context70.prev = _context70.next) {
          case 0:
            _context70.prev = 0;
            _context70.next = 3;
            return api.get("/quotes_plus/refresh-validation-after-purchase/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId));

          case 3:
            res = _context70.sent;
            handleApiRequestSuccessData(res);
            return _context70.abrupt("return", [res.data]);

          case 8:
            _context70.prev = 8;
            _context70.t0 = _context70["catch"](0);
            return _context70.abrupt("return", handleRequestError(_context70.t0, payload));

          case 11:
          case "end":
            return _context70.stop();
        }
      }
    }, _callee70, null, [[0, 8]]);
  }));

  return function apiGetQuoteValidationInfoAfterPurchase(_x85) {
    return _ref78.apply(this, arguments);
  };
}();
export var apiConfirmPolicyPaymentNotAlignStartDate = /*#__PURE__*/function () {
  var _ref79 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee71(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee71$(_context71) {
      while (1) {
        switch (_context71.prev = _context71.next) {
          case 0:
            _context71.prev = 0;
            _context71.next = 3;
            return api.post("/policies/".concat(payload === null || payload === void 0 ? void 0 : payload.policyId, "/confirm-loss-report"));

          case 3:
            res = _context71.sent;
            handleApiRequestSuccessData(res);
            return _context71.abrupt("return", [res.data]);

          case 8:
            _context71.prev = 8;
            _context71.t0 = _context71["catch"](0);
            return _context71.abrupt("return", handleRequestError(_context71.t0, payload));

          case 11:
          case "end":
            return _context71.stop();
        }
      }
    }, _callee71, null, [[0, 8]]);
  }));

  return function apiConfirmPolicyPaymentNotAlignStartDate(_x86) {
    return _ref79.apply(this, arguments);
  };
}();
export var apiGetQuoteAccountancyActivityList = /*#__PURE__*/function () {
  var _ref80 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee72(payload) {
    var _res$data9, res;

    return _regeneratorRuntime.wrap(function _callee72$(_context72) {
      while (1) {
        switch (_context72.prev = _context72.next) {
          case 0:
            _context72.prev = 0;
            _context72.next = 3;
            return api.get("/quotes_plus/accountancy-activity-split");

          case 3:
            res = _context72.sent;
            handleApiRequestSuccessData(res);

            if (isArray(res === null || res === void 0 ? void 0 : (_res$data9 = res.data) === null || _res$data9 === void 0 ? void 0 : _res$data9.data)) {
              res.data.data = res.data.data.map(function (item) {
                return {
                  value: item.code,
                  label: item.description
                };
              });
            }

            return _context72.abrupt("return", [res.data]);

          case 9:
            _context72.prev = 9;
            _context72.t0 = _context72["catch"](0);
            return _context72.abrupt("return", handleRequestError(_context72.t0, payload));

          case 12:
          case "end":
            return _context72.stop();
        }
      }
    }, _callee72, null, [[0, 9]]);
  }));

  return function apiGetQuoteAccountancyActivityList(_x87) {
    return _ref80.apply(this, arguments);
  };
}();
export var apiGetQuoteUnsignedDocumentBeforePayment = /*#__PURE__*/function () {
  var _ref81 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee73(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee73$(_context73) {
      while (1) {
        switch (_context73.prev = _context73.next) {
          case 0:
            _context73.prev = 0;
            _context73.next = 3;
            return api.get("/quotes/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId, "/unsigned-document-before-payment"));

          case 3:
            res = _context73.sent;
            handleApiRequestSuccessData(res);
            return _context73.abrupt("return", [res.data]);

          case 8:
            _context73.prev = 8;
            _context73.t0 = _context73["catch"](0);
            return _context73.abrupt("return", handleRequestError(_context73.t0, payload));

          case 11:
          case "end":
            return _context73.stop();
        }
      }
    }, _callee73, null, [[0, 8]]);
  }));

  return function apiGetQuoteUnsignedDocumentBeforePayment(_x88) {
    return _ref81.apply(this, arguments);
  };
}();
export var apiGetQuoteAllDetailInformation = /*#__PURE__*/function () {
  var _ref82 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee74(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee74$(_context74) {
      while (1) {
        switch (_context74.prev = _context74.next) {
          case 0:
            _context74.prev = 0;
            _context74.next = 3;
            return api.get("/quotes/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId));

          case 3:
            res = _context74.sent;
            handleApiRequestSuccessData(res);
            return _context74.abrupt("return", [res.data]);

          case 8:
            _context74.prev = 8;
            _context74.t0 = _context74["catch"](0);
            return _context74.abrupt("return", handleRequestError(_context74.t0, payload));

          case 11:
          case "end":
            return _context74.stop();
        }
      }
    }, _callee74, null, [[0, 8]]);
  }));

  return function apiGetQuoteAllDetailInformation(_x89) {
    return _ref82.apply(this, arguments);
  };
}();
export var apiQuoteCreateSubscriptionCheckoutSession = /*#__PURE__*/function () {
  var _ref83 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee75(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee75$(_context75) {
      while (1) {
        switch (_context75.prev = _context75.next) {
          case 0:
            _context75.prev = 0;
            _context75.next = 3;
            return api.post("/quotes/".concat(payload.quote_id, "/create-subscription-checkout-session"), payload);

          case 3:
            res = _context75.sent;
            return _context75.abrupt("return", [res.data]);

          case 7:
            _context75.prev = 7;
            _context75.t0 = _context75["catch"](0);
            return _context75.abrupt("return", handleRequestError(_context75.t0, payload));

          case 10:
          case "end":
            return _context75.stop();
        }
      }
    }, _callee75, null, [[0, 7]]);
  }));

  return function apiQuoteCreateSubscriptionCheckoutSession(_x90) {
    return _ref83.apply(this, arguments);
  };
}();
export var apiSendCustomerDirectDebitEmail = /*#__PURE__*/function () {
  var _ref84 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee76(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee76$(_context76) {
      while (1) {
        switch (_context76.prev = _context76.next) {
          case 0:
            _context76.prev = 0;
            _context76.next = 3;
            return api.post("/admin/quotes_plus/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId, "/send-direct-debit-notify-email"), payload);

          case 3:
            res = _context76.sent;
            handleApiRequestSuccessData(res);
            return _context76.abrupt("return", [res.data]);

          case 8:
            _context76.prev = 8;
            _context76.t0 = _context76["catch"](0);
            return _context76.abrupt("return", handleRequestError(_context76.t0, payload));

          case 11:
          case "end":
            return _context76.stop();
        }
      }
    }, _callee76, null, [[0, 8]]);
  }));

  return function apiSendCustomerDirectDebitEmail(_x91) {
    return _ref84.apply(this, arguments);
  };
}();
export var apiSetQuoteDecline = /*#__PURE__*/function () {
  var _ref85 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee77(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee77$(_context77) {
      while (1) {
        switch (_context77.prev = _context77.next) {
          case 0:
            _context77.prev = 0;
            _context77.next = 3;
            return api.patch("/admin/quotes/".concat(payload.quoteId, "/decline"));

          case 3:
            res = _context77.sent;
            handleApiRequestSuccessData(res);
            return _context77.abrupt("return", [res.data]);

          case 8:
            _context77.prev = 8;
            _context77.t0 = _context77["catch"](0);
            return _context77.abrupt("return", handleRequestError(_context77.t0, payload));

          case 11:
          case "end":
            return _context77.stop();
        }
      }
    }, _callee77, null, [[0, 8]]);
  }));

  return function apiSetQuoteDecline(_x92) {
    return _ref85.apply(this, arguments);
  };
}();
export var apiGetQuoteDetailInformation = /*#__PURE__*/function () {
  var _ref86 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee78(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee78$(_context78) {
      while (1) {
        switch (_context78.prev = _context78.next) {
          case 0:
            _context78.prev = 0;
            _context78.next = 3;
            return api.get("/quotes/".concat(payload === null || payload === void 0 ? void 0 : payload.quoteId));

          case 3:
            res = _context78.sent;
            handleApiRequestSuccessData(res);
            return _context78.abrupt("return", [res.data]);

          case 8:
            _context78.prev = 8;
            _context78.t0 = _context78["catch"](0);
            return _context78.abrupt("return", handleRequestError(_context78.t0, payload));

          case 11:
          case "end":
            return _context78.stop();
        }
      }
    }, _callee78, null, [[0, 8]]);
  }));

  return function apiGetQuoteDetailInformation(_x93) {
    return _ref86.apply(this, arguments);
  };
}();
export var apiSendQuoteApplicationForm = /*#__PURE__*/function () {
  var _ref87 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee79(payload) {
    return _regeneratorRuntime.wrap(function _callee79$(_context79) {
      while (1) {
        switch (_context79.prev = _context79.next) {
          case 0:
            _context79.next = 2;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 2000);
            });

          case 2:
            return _context79.abrupt("return", [{
              code: REQUEST_SUCCESS_CODE,
              payload: payload
            }]);

          case 3:
          case "end":
            return _context79.stop();
        }
      }
    }, _callee79);
  }));

  return function apiSendQuoteApplicationForm(_x94) {
    return _ref87.apply(this, arguments);
  };
}();